var _path, _path2, _path3, _g, _path4, _g2, _path5, _g3, _path6, _g4, _path7, _g5, _path8, _g6, _path9, _g7, _path10, _path11, _g8, _path12, _path13, _g9, _path14, _path15, _g10, _path16, _g11, _path17, _g12, _path18, _g13, _path19, _path20, _g14, _path21, _g15, _path22, _g16, _path23, _g17, _path24, _g18, _path25, _path26, _g19, _path27, _g20, _path28, _path29, _path30, _g21, _path31, _g22, _g23, _path32, _path33, _path34, _g24, _path35, _g25, _g26, _path36, _g27, _path37, _g28, _path38, _path39, _path40, _g29, _path41, _g30, _path42, _path43, _g31, _g32, _g33, _path44, _path45, _g34, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinuxLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5038_39507)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_5038_39507)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8688 0.5C15.1188 0.5 14.3663 0.6475 13.6863 1.015C12.9638 1.40375 12.3713 2.02625 12.0075 2.76125C11.6425 3.49625 11.5 4.28125 11.4775 5.14625C11.4363 6.78875 11.515 8.51125 11.6388 10.0725C11.6713 10.5475 11.7313 10.825 11.67 11.3138C11.4675 12.3513 10.56 13.0487 10.075 13.96C9.54128 14.965 9.31628 16.1012 8.91378 17.1663C8.54503 18.14 8.02753 19.0537 7.67878 20.035C7.19003 21.4062 7.04378 22.9137 7.36628 24.3337C7.61253 25.4163 8.12628 26.4312 8.81878 27.3C8.71878 27.48 8.62128 27.6638 8.51878 27.8425C8.19753 28.3962 7.80503 28.9225 7.62253 29.5362C7.53128 29.8425 7.49503 30.17 7.55378 30.485C7.61253 30.8 7.77253 31.1012 8.02253 31.3013C8.18628 31.4312 8.38503 31.5162 8.58878 31.5637C8.79253 31.61 9.00378 31.6213 9.21378 31.6175C10.01 31.6 10.7825 31.3587 11.5525 31.1562C12.01 31.0362 12.47 30.93 12.9313 30.8337C14.5738 30.4975 16.4063 30.6325 17.93 30.8525C18.4463 30.9313 18.9588 31.0325 19.4663 31.1562C20.2613 31.3487 21.0525 31.5938 21.87 31.6175C22.085 31.6238 22.3025 31.6137 22.5125 31.5675C22.7225 31.52 22.9263 31.435 23.0938 31.3013C23.345 31.1012 23.505 30.7987 23.5638 30.4837C23.6225 30.1687 23.5863 29.84 23.4938 29.5325C23.3088 28.9175 22.9125 28.3938 22.585 27.8425C22.455 27.6238 22.335 27.4013 22.2063 27.1825C23.1938 26.0738 23.9888 24.7913 24.4488 23.3825C24.95 21.845 25.0425 20.1887 24.8313 18.585C24.62 16.9812 24.1113 15.4262 23.4425 13.9537C22.6025 12.1087 21.8963 11.4412 21.3838 9.82C20.8313 8.0675 21.2875 5.99375 20.8763 4.405C20.73 3.865 20.4963 3.34875 20.195 2.87625C19.8425 2.3225 19.395 1.8275 18.8638 1.4425C18.0163 0.8275 16.9513 0.5 15.8688 0.5Z",
    fill: "#020204"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8913 9.75021C12.7788 9.89146 12.7063 10.0615 12.6613 10.2365C12.6175 10.4115 12.6013 10.5927 12.5938 10.774C12.58 11.1352 12.6025 11.5027 12.5063 11.8515C12.4038 12.224 12.175 12.5477 11.9513 12.8615C11.5625 13.4065 11.17 13.9665 10.9788 14.6077C10.8625 14.9952 10.8238 15.4065 10.865 15.8102C10.4313 16.4477 10.055 17.1265 9.74253 17.8327C9.27003 18.904 8.94628 20.044 8.83253 21.209C8.69253 22.6352 8.87503 24.1027 9.43878 25.4202C9.84503 26.374 10.4525 27.2452 11.2363 27.9252C11.6338 28.2702 12.0763 28.564 12.5488 28.7965C14.1875 29.6027 16.2125 29.604 17.8238 28.7452C18.6663 28.2965 19.3775 27.6402 20.0625 26.9765C20.475 26.5765 20.8863 26.1665 21.2013 25.6865C21.8075 24.7602 22.0188 23.6352 22.15 22.5365C22.3788 20.6165 22.3863 18.5865 21.5438 16.8452C21.2538 16.2452 20.8675 15.6927 20.4038 15.214C20.2813 14.3765 20.0375 13.5552 19.6838 12.7865C19.4275 12.2302 19.1163 11.7015 18.8788 11.139C18.7813 10.9077 18.6963 10.6702 18.5888 10.444C18.48 10.2177 18.3475 10.0002 18.165 9.82646C17.98 9.64896 17.7488 9.52271 17.505 9.44271C17.2613 9.36146 17.0038 9.32521 16.7475 9.31271C16.2338 9.28646 15.72 9.35396 15.2063 9.33271C14.7975 9.31646 14.39 9.24521 13.9813 9.26896C13.7775 9.28146 13.5738 9.31771 13.3838 9.39521C13.1938 9.47146 13.0188 9.59021 12.8913 9.75021Z",
    fill: "#FDFDFB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5038_39507",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 0,
    width: 18,
    height: 32
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8688 0.5C15.1188 0.5 14.3663 0.6475 13.6863 1.015C12.9638 1.40375 12.3713 2.02625 12.0075 2.76125C11.6425 3.49625 11.5 4.28125 11.4775 5.14625C11.4363 6.78875 11.515 8.51125 11.6388 10.0725C11.6713 10.5475 11.7313 10.825 11.67 11.3138C11.4675 12.3513 10.56 13.0487 10.075 13.96C9.54128 14.965 9.31628 16.1012 8.91378 17.1663C8.54503 18.14 8.02753 19.0537 7.67878 20.035C7.19003 21.4062 7.04378 22.9137 7.36628 24.3337C7.61253 25.4163 8.12628 26.4312 8.81878 27.3C8.71878 27.48 8.62128 27.6638 8.51878 27.8425C8.19753 28.3962 7.80503 28.9225 7.62253 29.5362C7.53128 29.8425 7.49503 30.17 7.55378 30.485C7.61253 30.8 7.77253 31.1012 8.02253 31.3013C8.18628 31.4312 8.38503 31.5162 8.58878 31.5637C8.79253 31.61 9.00378 31.6213 9.21378 31.6175C10.01 31.6 10.7825 31.3587 11.5525 31.1562C12.01 31.0362 12.47 30.93 12.9313 30.8337C14.5738 30.4975 16.4063 30.6325 17.93 30.8525C18.4463 30.9313 18.9588 31.0325 19.4663 31.1562C20.2613 31.3487 21.0525 31.5938 21.87 31.6175C22.085 31.6238 22.3025 31.6137 22.5125 31.5675C22.7225 31.52 22.9263 31.435 23.0938 31.3013C23.345 31.1012 23.505 30.7987 23.5638 30.4837C23.6225 30.1687 23.5863 29.84 23.4938 29.5325C23.3088 28.9175 22.9125 28.3938 22.585 27.8425C22.455 27.6238 22.335 27.4013 22.2063 27.1825C23.1938 26.0738 23.9888 24.7913 24.4488 23.3825C24.95 21.845 25.0425 20.1887 24.8313 18.585C24.62 16.9812 24.1113 15.4262 23.4425 13.9537C22.6025 12.1087 21.8963 11.4412 21.3838 9.82C20.8313 8.0675 21.2875 5.99375 20.8763 4.405C20.73 3.865 20.4963 3.34875 20.195 2.87625C19.8425 2.3225 19.395 1.8275 18.8638 1.4425C18.0163 0.8275 16.9513 0.5 15.8688 0.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5038_39507)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.25,
    filter: "url(#filter0_f_5038_39507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0838 14.8976C11.1925 15.0614 11.015 15.6276 13.5663 15.2651C13.5663 15.2651 13.1175 15.3139 12.6763 15.4164C11.99 15.6464 11.3925 15.9026 10.93 16.2426C10.4738 16.5801 10.1388 17.0189 9.72003 17.3951C9.72003 17.3951 10.3988 16.1551 10.5675 15.7814C10.7375 15.4076 10.54 15.4251 10.6738 14.8751C10.8075 14.3251 11.135 13.7964 11.135 13.7964C11.135 13.7964 10.8675 14.5739 11.0838 14.8976Z",
    fill: "url(#paint0_radial_5038_39507)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_5038_39507",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 0,
    width: 18,
    height: 32
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8688 0.5C15.1188 0.5 14.3663 0.6475 13.6863 1.015C12.9638 1.40375 12.3713 2.02625 12.0075 2.76125C11.6425 3.49625 11.5 4.28125 11.4775 5.14625C11.4363 6.78875 11.515 8.51125 11.6388 10.0725C11.6713 10.5475 11.7313 10.825 11.67 11.3138C11.4675 12.3513 10.56 13.0487 10.075 13.96C9.54128 14.965 9.31628 16.1012 8.91378 17.1663C8.54503 18.14 8.02753 19.0537 7.67878 20.035C7.19003 21.4062 7.04378 22.9137 7.36628 24.3337C7.61253 25.4163 8.12628 26.4312 8.81878 27.3C8.71878 27.48 8.62128 27.6638 8.51878 27.8425C8.19753 28.3962 7.80503 28.9225 7.62253 29.5362C7.53128 29.8425 7.49503 30.17 7.55378 30.485C7.61253 30.8 7.77253 31.1012 8.02253 31.3013C8.18628 31.4312 8.38503 31.5162 8.58878 31.5637C8.79253 31.61 9.00378 31.6213 9.21378 31.6175C10.01 31.6 10.7825 31.3587 11.5525 31.1562C12.01 31.0362 12.47 30.93 12.9313 30.8337C14.5738 30.4975 16.4063 30.6325 17.93 30.8525C18.4463 30.9313 18.9588 31.0325 19.4663 31.1562C20.2613 31.3487 21.0525 31.5938 21.87 31.6175C22.085 31.6238 22.3025 31.6137 22.5125 31.5675C22.7225 31.52 22.9263 31.435 23.0938 31.3013C23.345 31.1012 23.505 30.7987 23.5638 30.4837C23.6225 30.1687 23.5863 29.84 23.4938 29.5325C23.3088 28.9175 22.9125 28.3938 22.585 27.8425C22.455 27.6238 22.335 27.4013 22.2063 27.1825C23.1938 26.0738 23.9888 24.7913 24.4488 23.3825C24.95 21.845 25.0425 20.1887 24.8313 18.585C24.62 16.9812 24.1113 15.4262 23.4425 13.9537C22.6025 12.1087 21.8963 11.4412 21.3838 9.82C20.8313 8.0675 21.2875 5.99375 20.8763 4.405C20.73 3.865 20.4963 3.34875 20.195 2.87625C19.8425 2.3225 19.395 1.8275 18.8638 1.4425C18.0163 0.8275 16.9513 0.5 15.8688 0.5Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_5038_39507)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.42,
    filter: "url(#filter1_f_5038_39507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.2851 14.7487C18.7651 15.1112 18.4601 15.0687 17.8301 15.1387C17.1988 15.2099 15.4926 15.1837 15.4926 15.1837C15.4926 15.1837 15.7388 15.1799 16.2876 15.2812C16.8351 15.3837 17.9513 15.4812 18.5801 15.7199C19.2101 15.9599 19.4388 16.0287 19.8213 16.2699C20.3651 16.6137 20.7651 17.1524 21.2851 17.5299C21.2851 17.5299 21.3101 17.0299 21.1001 16.6562C20.8901 16.2824 20.3251 15.6937 20.1588 15.1437C19.9938 14.5937 19.9138 13.5137 19.9138 13.5137C19.9138 13.5137 19.8038 14.3874 19.2851 14.7487Z",
    fill: "url(#paint1_radial_5038_39507)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_5038_39507",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 0,
    width: 18,
    height: 32
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8688 0.5C15.1188 0.5 14.3663 0.6475 13.6863 1.015C12.9638 1.40375 12.3713 2.02625 12.0075 2.76125C11.6425 3.49625 11.5 4.28125 11.4775 5.14625C11.4363 6.78875 11.515 8.51125 11.6388 10.0725C11.6713 10.5475 11.7313 10.825 11.67 11.3138C11.4675 12.3513 10.56 13.0487 10.075 13.96C9.54128 14.965 9.31628 16.1012 8.91378 17.1663C8.54503 18.14 8.02753 19.0537 7.67878 20.035C7.19003 21.4062 7.04378 22.9137 7.36628 24.3337C7.61253 25.4163 8.12628 26.4312 8.81878 27.3C8.71878 27.48 8.62128 27.6638 8.51878 27.8425C8.19753 28.3962 7.80503 28.9225 7.62253 29.5362C7.53128 29.8425 7.49503 30.17 7.55378 30.485C7.61253 30.8 7.77253 31.1012 8.02253 31.3013C8.18628 31.4312 8.38503 31.5162 8.58878 31.5637C8.79253 31.61 9.00378 31.6213 9.21378 31.6175C10.01 31.6 10.7825 31.3587 11.5525 31.1562C12.01 31.0362 12.47 30.93 12.9313 30.8337C14.5738 30.4975 16.4063 30.6325 17.93 30.8525C18.4463 30.9313 18.9588 31.0325 19.4663 31.1562C20.2613 31.3487 21.0525 31.5938 21.87 31.6175C22.085 31.6238 22.3025 31.6137 22.5125 31.5675C22.7225 31.52 22.9263 31.435 23.0938 31.3013C23.345 31.1012 23.505 30.7987 23.5638 30.4837C23.6225 30.1687 23.5863 29.84 23.4938 29.5325C23.3088 28.9175 22.9125 28.3938 22.585 27.8425C22.455 27.6238 22.335 27.4013 22.2063 27.1825C23.1938 26.0738 23.9888 24.7913 24.4488 23.3825C24.95 21.845 25.0425 20.1887 24.8313 18.585C24.62 16.9812 24.1113 15.4262 23.4425 13.9537C22.6025 12.1087 21.8963 11.4412 21.3838 9.82C20.8313 8.0675 21.2875 5.99375 20.8763 4.405C20.73 3.865 20.4963 3.34875 20.195 2.87625C19.8425 2.3225 19.395 1.8275 18.8638 1.4425C18.0163 0.8275 16.9513 0.5 15.8688 0.5Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_5038_39507)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter2_f_5038_39507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.3963 13.9761C14.3763 14.1323 14.3513 14.2886 14.3213 14.4436C14.3063 14.5198 14.2888 14.5961 14.2613 14.6686C14.2325 14.7411 14.1913 14.8111 14.1338 14.8623C14.0825 14.9086 14.0213 14.9398 13.9588 14.9686C13.7163 15.0786 13.4575 15.1523 13.1938 15.1861C13.2988 15.1936 13.4038 15.2036 13.51 15.2148C13.5763 15.2223 13.6425 15.2298 13.7063 15.2461C13.7713 15.2636 13.835 15.2886 13.8888 15.3273C13.9475 15.3711 13.9938 15.4298 14.0288 15.4948C14.0975 15.6223 14.12 15.7698 14.1325 15.9161C14.1488 16.1011 14.15 16.2886 14.1363 16.4736C14.1488 16.3498 14.175 16.2261 14.2138 16.1086C14.285 15.8936 14.3975 15.6936 14.55 15.5273C14.6113 15.4623 14.6775 15.4011 14.75 15.3498C14.9738 15.1923 15.2588 15.1236 15.53 15.1611C15.2538 15.1723 14.975 15.0861 14.755 14.9198C14.6425 14.8348 14.545 14.7298 14.4775 14.6073C14.3725 14.4173 14.3425 14.1861 14.3963 13.9761Z",
    fill: "url(#paint2_radial_5038_39507)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_5038_39507",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 0,
    width: 18,
    height: 32
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8688 0.5C15.1188 0.5 14.3663 0.6475 13.6863 1.015C12.9638 1.40375 12.3713 2.02625 12.0075 2.76125C11.6425 3.49625 11.5 4.28125 11.4775 5.14625C11.4363 6.78875 11.515 8.51125 11.6388 10.0725C11.6713 10.5475 11.7313 10.825 11.67 11.3138C11.4675 12.3513 10.56 13.0487 10.075 13.96C9.54128 14.965 9.31628 16.1012 8.91378 17.1663C8.54503 18.14 8.02753 19.0537 7.67878 20.035C7.19003 21.4062 7.04378 22.9137 7.36628 24.3337C7.61253 25.4163 8.12628 26.4312 8.81878 27.3C8.71878 27.48 8.62128 27.6638 8.51878 27.8425C8.19753 28.3962 7.80503 28.9225 7.62253 29.5362C7.53128 29.8425 7.49503 30.17 7.55378 30.485C7.61253 30.8 7.77253 31.1012 8.02253 31.3013C8.18628 31.4312 8.38503 31.5162 8.58878 31.5637C8.79253 31.61 9.00378 31.6213 9.21378 31.6175C10.01 31.6 10.7825 31.3587 11.5525 31.1562C12.01 31.0362 12.47 30.93 12.9313 30.8337C14.5738 30.4975 16.4063 30.6325 17.93 30.8525C18.4463 30.9313 18.9588 31.0325 19.4663 31.1562C20.2613 31.3487 21.0525 31.5938 21.87 31.6175C22.085 31.6238 22.3025 31.6137 22.5125 31.5675C22.7225 31.52 22.9263 31.435 23.0938 31.3013C23.345 31.1012 23.505 30.7987 23.5638 30.4837C23.6225 30.1687 23.5863 29.84 23.4938 29.5325C23.3088 28.9175 22.9125 28.3938 22.585 27.8425C22.455 27.6238 22.335 27.4013 22.2063 27.1825C23.1938 26.0738 23.9888 24.7913 24.4488 23.3825C24.95 21.845 25.0425 20.1887 24.8313 18.585C24.62 16.9812 24.1113 15.4262 23.4425 13.9537C22.6025 12.1087 21.8963 11.4412 21.3838 9.82C20.8313 8.0675 21.2875 5.99375 20.8763 4.405C20.73 3.865 20.4963 3.34875 20.195 2.87625C19.8425 2.3225 19.395 1.8275 18.8638 1.4425C18.0163 0.8275 16.9513 0.5 15.8688 0.5Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_5038_39507)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.11,
    filter: "url(#filter3_f_5038_39507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7313 17.6426C13.5988 18.1463 13.5075 18.6613 13.46 19.1813C13.3913 19.9151 13.4075 20.6538 13.3675 21.3901C13.335 22.0138 13.2613 22.6451 13.37 23.2613C13.4213 23.5551 13.5138 23.8413 13.645 24.1088C13.665 24.0063 13.6813 23.9038 13.69 23.8001C13.7363 23.3001 13.6525 22.7988 13.6238 22.2988C13.5738 21.4213 13.695 20.5438 13.745 19.6663C13.7825 18.9926 13.7788 18.3163 13.7313 17.6426Z",
    fill: "black"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_5038_39507",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 0,
    width: 18,
    height: 32
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8688 0.5C15.1188 0.5 14.3663 0.6475 13.6863 1.015C12.9638 1.40375 12.3713 2.02625 12.0075 2.76125C11.6425 3.49625 11.5 4.28125 11.4775 5.14625C11.4363 6.78875 11.515 8.51125 11.6388 10.0725C11.6713 10.5475 11.7313 10.825 11.67 11.3138C11.4675 12.3513 10.56 13.0487 10.075 13.96C9.54128 14.965 9.31628 16.1012 8.91378 17.1663C8.54503 18.14 8.02753 19.0537 7.67878 20.035C7.19003 21.4062 7.04378 22.9137 7.36628 24.3337C7.61253 25.4163 8.12628 26.4312 8.81878 27.3C8.71878 27.48 8.62128 27.6638 8.51878 27.8425C8.19753 28.3962 7.80503 28.9225 7.62253 29.5362C7.53128 29.8425 7.49503 30.17 7.55378 30.485C7.61253 30.8 7.77253 31.1012 8.02253 31.3013C8.18628 31.4312 8.38503 31.5162 8.58878 31.5637C8.79253 31.61 9.00378 31.6213 9.21378 31.6175C10.01 31.6 10.7825 31.3587 11.5525 31.1562C12.01 31.0362 12.47 30.93 12.9313 30.8337C14.5738 30.4975 16.4063 30.6325 17.93 30.8525C18.4463 30.9313 18.9588 31.0325 19.4663 31.1562C20.2613 31.3487 21.0525 31.5938 21.87 31.6175C22.085 31.6238 22.3025 31.6137 22.5125 31.5675C22.7225 31.52 22.9263 31.435 23.0938 31.3013C23.345 31.1012 23.505 30.7987 23.5638 30.4837C23.6225 30.1687 23.5863 29.84 23.4938 29.5325C23.3088 28.9175 22.9125 28.3938 22.585 27.8425C22.455 27.6238 22.335 27.4013 22.2063 27.1825C23.1938 26.0738 23.9888 24.7913 24.4488 23.3825C24.95 21.845 25.0425 20.1887 24.8313 18.585C24.62 16.9812 24.1113 15.4262 23.4425 13.9537C22.6025 12.1087 21.8963 11.4412 21.3838 9.82C20.8313 8.0675 21.2875 5.99375 20.8763 4.405C20.73 3.865 20.4963 3.34875 20.195 2.87625C19.8425 2.3225 19.395 1.8275 18.8638 1.4425C18.0163 0.8275 16.9513 0.5 15.8688 0.5Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_5038_39507)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.75,
    filter: "url(#filter4_f_5038_39507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.51 16.9038C22.6388 16.8838 23.4275 17.555 23.32 17.805C23.2125 18.0538 23.0088 17.9038 22.8638 17.905C22.7188 17.9075 22.3225 18.0875 22.2563 17.9738C22.1888 17.86 22.4313 17.595 22.5575 17.3725C22.66 17.1938 22.3825 16.9238 22.51 16.9038Z",
    fill: "#7C7C7C"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_5038_39507",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 0,
    width: 18,
    height: 32
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8688 0.5C15.1188 0.5 14.3663 0.6475 13.6863 1.015C12.9638 1.40375 12.3713 2.02625 12.0075 2.76125C11.6425 3.49625 11.5 4.28125 11.4775 5.14625C11.4363 6.78875 11.515 8.51125 11.6388 10.0725C11.6713 10.5475 11.7313 10.825 11.67 11.3138C11.4675 12.3513 10.56 13.0487 10.075 13.96C9.54128 14.965 9.31628 16.1012 8.91378 17.1663C8.54503 18.14 8.02753 19.0537 7.67878 20.035C7.19003 21.4062 7.04378 22.9137 7.36628 24.3337C7.61253 25.4163 8.12628 26.4312 8.81878 27.3C8.71878 27.48 8.62128 27.6638 8.51878 27.8425C8.19753 28.3962 7.80503 28.9225 7.62253 29.5362C7.53128 29.8425 7.49503 30.17 7.55378 30.485C7.61253 30.8 7.77253 31.1012 8.02253 31.3013C8.18628 31.4312 8.38503 31.5162 8.58878 31.5637C8.79253 31.61 9.00378 31.6213 9.21378 31.6175C10.01 31.6 10.7825 31.3587 11.5525 31.1562C12.01 31.0362 12.47 30.93 12.9313 30.8337C14.5738 30.4975 16.4063 30.6325 17.93 30.8525C18.4463 30.9313 18.9588 31.0325 19.4663 31.1562C20.2613 31.3487 21.0525 31.5938 21.87 31.6175C22.085 31.6238 22.3025 31.6137 22.5125 31.5675C22.7225 31.52 22.9263 31.435 23.0938 31.3013C23.345 31.1012 23.505 30.7987 23.5638 30.4837C23.6225 30.1687 23.5863 29.84 23.4938 29.5325C23.3088 28.9175 22.9125 28.3938 22.585 27.8425C22.455 27.6238 22.335 27.4013 22.2063 27.1825C23.1938 26.0738 23.9888 24.7913 24.4488 23.3825C24.95 21.845 25.0425 20.1887 24.8313 18.585C24.62 16.9812 24.1113 15.4262 23.4425 13.9537C22.6025 12.1087 21.8963 11.4412 21.3838 9.82C20.8313 8.0675 21.2875 5.99375 20.8763 4.405C20.73 3.865 20.4963 3.34875 20.195 2.87625C19.8425 2.3225 19.395 1.8275 18.8638 1.4425C18.0163 0.8275 16.9513 0.5 15.8688 0.5Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_5038_39507)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_5038_39507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.69 1.89003C17.4138 2.08503 17.5338 2.32878 17.6525 2.57253C17.7713 2.81753 17.3913 3.52128 17.3875 3.55128C17.3838 3.58128 18.135 3.19503 18.34 2.94253C18.5825 2.64628 19.1938 3.34503 19.16 3.23878C19.1613 3.04878 17.9663 1.69628 17.69 1.89003Z",
    fill: "#7C7C7C"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_5038_39507",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 0,
    width: 18,
    height: 32
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8688 0.5C15.1188 0.5 14.3663 0.6475 13.6863 1.015C12.9638 1.40375 12.3713 2.02625 12.0075 2.76125C11.6425 3.49625 11.5 4.28125 11.4775 5.14625C11.4363 6.78875 11.515 8.51125 11.6388 10.0725C11.6713 10.5475 11.7313 10.825 11.67 11.3138C11.4675 12.3513 10.56 13.0487 10.075 13.96C9.54128 14.965 9.31628 16.1012 8.91378 17.1663C8.54503 18.14 8.02753 19.0537 7.67878 20.035C7.19003 21.4062 7.04378 22.9137 7.36628 24.3337C7.61253 25.4163 8.12628 26.4312 8.81878 27.3C8.71878 27.48 8.62128 27.6638 8.51878 27.8425C8.19753 28.3962 7.80503 28.9225 7.62253 29.5362C7.53128 29.8425 7.49503 30.17 7.55378 30.485C7.61253 30.8 7.77253 31.1012 8.02253 31.3013C8.18628 31.4312 8.38503 31.5162 8.58878 31.5637C8.79253 31.61 9.00378 31.6213 9.21378 31.6175C10.01 31.6 10.7825 31.3587 11.5525 31.1562C12.01 31.0362 12.47 30.93 12.9313 30.8337C14.5738 30.4975 16.4063 30.6325 17.93 30.8525C18.4463 30.9313 18.9588 31.0325 19.4663 31.1562C20.2613 31.3487 21.0525 31.5938 21.87 31.6175C22.085 31.6238 22.3025 31.6137 22.5125 31.5675C22.7225 31.52 22.9263 31.435 23.0938 31.3013C23.345 31.1012 23.505 30.7987 23.5638 30.4837C23.6225 30.1687 23.5863 29.84 23.4938 29.5325C23.3088 28.9175 22.9125 28.3938 22.585 27.8425C22.455 27.6238 22.335 27.4013 22.2063 27.1825C23.1938 26.0738 23.9888 24.7913 24.4488 23.3825C24.95 21.845 25.0425 20.1887 24.8313 18.585C24.62 16.9812 24.1113 15.4262 23.4425 13.9537C22.6025 12.1087 21.8963 11.4412 21.3838 9.82C20.8313 8.0675 21.2875 5.99375 20.8763 4.405C20.73 3.865 20.4963 3.34875 20.195 2.87625C19.8425 2.3225 19.395 1.8275 18.8638 1.4425C18.0163 0.8275 16.9513 0.5 15.8688 0.5Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_5038_39507)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_5038_39507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7838 10.0787C19.5513 10.2912 19.8938 10.6099 20.0551 10.9837C20.1563 11.2162 20.4351 11.5449 20.7051 11.4924C20.9088 11.4524 21.0338 11.1599 21.0151 10.9549C20.9776 10.5574 20.6426 10.4637 20.3988 10.3274C20.2063 10.2199 19.9476 9.92994 19.7838 10.0787Z",
    fill: "#838384"
  })))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4975 13.1137C9.73504 13.9787 8.95129 14.8175 8.52129 15.7537C8.30754 16.2287 8.20754 16.745 8.06129 17.245C7.89629 17.8125 7.67129 18.3625 7.41879 18.8975C7.18504 19.3912 6.92754 19.8737 6.67129 20.355C6.48379 20.7062 6.29379 21.0637 6.22879 21.4562C6.17754 21.7662 6.20629 22.0862 6.28629 22.39C6.36504 22.6937 6.49129 22.9837 6.63504 23.2625C7.24504 24.4562 8.16129 25.4837 9.24629 26.2712C9.73879 26.6275 10.265 26.9362 10.8188 27.19C11.1188 27.3262 11.4338 27.4487 11.7638 27.4537C11.9288 27.4575 12.095 27.43 12.2463 27.3637C12.3963 27.2975 12.5313 27.1912 12.6213 27.0525C12.7313 26.8825 12.7688 26.6712 12.7463 26.47C12.7238 26.2687 12.645 26.0762 12.54 25.9037C12.2825 25.4812 11.8763 25.175 11.485 24.8725C10.64 24.2187 9.82379 23.5275 9.04129 22.8C8.82129 22.5937 8.60004 22.3825 8.44629 22.1225C8.29629 21.87 8.21504 21.5825 8.16004 21.2937C8.00879 20.5025 8.04754 19.67 8.31629 18.91C8.42254 18.6125 8.56129 18.3287 8.69629 18.0437C8.92879 17.55 9.14879 17.0462 9.45504 16.5937C9.83629 16.03 10.3463 15.5525 10.6563 14.9475C10.9188 14.4362 11.025 13.8625 11.1263 13.2975C11.2063 12.855 11.3575 12.4225 11.435 11.98C11.2838 12.2675 10.7963 12.7387 10.4975 13.1137Z",
    fill: "#020204"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_5038_39507",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 11,
    width: 7,
    height: 17
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4975 13.1137C9.73504 13.9787 8.95129 14.8175 8.52129 15.7537C8.30754 16.2287 8.20754 16.745 8.06129 17.245C7.89629 17.8125 7.67129 18.3625 7.41879 18.8975C7.18504 19.3912 6.92754 19.8737 6.67129 20.355C6.48379 20.7062 6.29379 21.0637 6.22879 21.4562C6.17754 21.7662 6.20629 22.0862 6.28629 22.39C6.36504 22.6937 6.49129 22.9837 6.63504 23.2625C7.24504 24.4562 8.16129 25.4837 9.24629 26.2712C9.73879 26.6275 10.265 26.9362 10.8188 27.19C11.1188 27.3262 11.4338 27.4487 11.7638 27.4537C11.9288 27.4575 12.095 27.43 12.2463 27.3637C12.3963 27.2975 12.5313 27.1912 12.6213 27.0525C12.7313 26.8825 12.7688 26.6712 12.7463 26.47C12.7238 26.2687 12.645 26.0762 12.54 25.9037C12.2825 25.4812 11.8763 25.175 11.485 24.8725C10.64 24.2187 9.82379 23.5275 9.04129 22.8C8.82129 22.5937 8.60004 22.3825 8.44629 22.1225C8.29629 21.87 8.21504 21.5825 8.16004 21.2937C8.00879 20.5025 8.04754 19.67 8.31629 18.91C8.42254 18.6125 8.56129 18.3287 8.69629 18.0437C8.92879 17.55 9.14879 17.0462 9.45504 16.5937C9.83629 16.03 10.3463 15.5525 10.6563 14.9475C10.9188 14.4362 11.025 13.8625 11.1263 13.2975C11.2063 12.855 11.3575 12.4225 11.435 11.98C11.2838 12.2675 10.7963 12.7387 10.4975 13.1137Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_5038_39507)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.95,
    filter: "url(#filter7_f_5038_39507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.62002 16.2625C9.37002 16.4925 9.15377 16.7588 8.97877 17.0513C8.69127 17.5313 8.52252 18.0713 8.31252 18.59C8.15752 18.9763 7.97627 19.365 7.95502 19.7813C7.94377 19.995 7.97502 20.2088 7.98252 20.4225C7.99002 20.6363 7.97002 20.8588 7.86502 21.045C7.77752 21.2013 7.63127 21.3238 7.46252 21.3838C7.69127 21.46 7.89377 21.6075 8.03752 21.8C8.15752 21.9625 8.23502 22.1513 8.33877 22.3225C8.42377 22.4625 8.52752 22.5925 8.65627 22.6938C8.78377 22.7963 8.93752 22.8688 9.09877 22.8888C9.32252 22.9175 9.55502 22.8438 9.72002 22.6913C9.51252 20.7475 9.70252 18.7638 10.275 16.895C10.3113 16.7775 10.3488 16.6588 10.3588 16.5363C10.3675 16.4125 10.3438 16.2825 10.2688 16.185C10.23 16.1325 10.1763 16.0913 10.115 16.065C10.055 16.04 9.98752 16.03 9.92252 16.0388C9.85752 16.0463 9.79377 16.0713 9.74127 16.11C9.68877 16.15 9.64627 16.2025 9.62002 16.2625Z",
    fill: "#7C7C7C"
  })))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M22.845 16.3898C23.5 16.9173 23.9163 17.7136 24.045 18.5448C24.145 19.1923 24.08 19.8586 23.9338 20.4973C23.7875 21.1373 23.5625 21.7548 23.3375 22.3723C23.2488 22.6173 23.1588 22.8661 23.1238 23.1248C23.0875 23.3848 23.11 23.6586 23.235 23.8886C23.3788 24.1523 23.6463 24.3336 23.9338 24.4186C24.2175 24.5036 24.5238 24.5011 24.8113 24.4298C25.0988 24.3586 25.5825 24.2661 25.8163 24.0836C26.41 23.6223 26.5513 22.8211 26.6925 22.1186C26.8388 21.3848 26.7675 20.6161 26.6388 19.8748C26.4625 18.8636 26.1663 17.8761 25.79 16.9223C25.5125 16.2198 25.1575 15.5498 24.735 14.9273C24.32 14.3161 23.7325 13.8398 23.2975 13.2423C23.1463 13.0348 22.965 12.8198 22.8175 12.6098C22.4975 12.1573 22.57 12.2423 22.3713 11.9486C22.2275 11.7361 22 11.6636 21.7613 11.5711C21.5213 11.4786 21.2538 11.4511 21.0063 11.5198C20.6813 11.6111 20.415 11.8686 20.2738 12.1748C20.1325 12.4823 20.1075 12.8348 20.1625 13.1686C20.2338 13.5986 20.43 13.9986 20.6525 14.3736C20.9025 14.7973 21.1925 15.2061 21.5713 15.5211C21.9663 15.8498 22.4438 16.0673 22.845 16.3898Z",
    fill: "#020204"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_5038_39507",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 11,
    width: 7,
    height: 14
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M22.845 16.3898C23.5 16.9173 23.9163 17.7136 24.045 18.5448C24.145 19.1923 24.08 19.8586 23.9338 20.4973C23.7875 21.1373 23.5625 21.7548 23.3375 22.3723C23.2488 22.6173 23.1588 22.8661 23.1238 23.1248C23.0875 23.3848 23.11 23.6586 23.235 23.8886C23.3788 24.1523 23.6463 24.3336 23.9338 24.4186C24.2175 24.5036 24.5238 24.5011 24.8113 24.4298C25.0988 24.3586 25.5825 24.2661 25.8163 24.0836C26.41 23.6223 26.5513 22.8211 26.6925 22.1186C26.8388 21.3848 26.7675 20.6161 26.6388 19.8748C26.4625 18.8636 26.1663 17.8761 25.79 16.9223C25.5125 16.2198 25.1575 15.5498 24.735 14.9273C24.32 14.3161 23.7325 13.8398 23.2975 13.2423C23.1463 13.0348 22.965 12.8198 22.8175 12.6098C22.4975 12.1573 22.57 12.2423 22.3713 11.9486C22.2275 11.7361 22 11.6636 21.7613 11.5711C21.5213 11.4786 21.2538 11.4511 21.0063 11.5198C20.6813 11.6111 20.415 11.8686 20.2738 12.1748C20.1325 12.4823 20.1075 12.8348 20.1625 13.1686C20.2338 13.5986 20.43 13.9986 20.6525 14.3736C20.9025 14.7973 21.1925 15.2061 21.5713 15.5211C21.9663 15.8498 22.4438 16.0673 22.845 16.3898Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_5038_39507)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_f_5038_39507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.3025 15.3735C21.355 15.4235 21.41 15.4748 21.4662 15.5223C21.8687 15.851 22.0825 16.2198 22.4912 16.5423C23.1587 17.0698 23.835 17.9798 23.9662 18.811C24.0687 19.4598 23.9337 19.8123 23.7687 20.576C23.6037 21.341 23.1362 22.4235 22.8825 23.161C22.7825 23.4548 23.0875 23.3335 23.0475 23.6435C23.0275 23.796 23.025 23.9498 23.0437 24.1023C23.0462 24.0735 23.0475 24.0423 23.0512 24.0135C23.1 23.591 23.2287 23.1848 23.37 22.786C23.6412 22.0198 23.9525 21.2673 24.1675 20.4798C24.3825 19.6935 24.3587 19.1273 24.2462 18.451C24.105 17.5998 23.61 16.8148 22.91 16.296C22.4137 15.9298 21.83 15.6948 21.3025 15.3735Z",
    fill: "#838384"
  })))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M6.87256 22.4165C7.04506 22.3452 7.23881 22.3315 7.42131 22.3652C7.60506 22.399 7.77881 22.479 7.93256 22.5827C8.24131 22.7927 8.47006 23.0977 8.68881 23.4002C9.19256 24.0927 9.67631 24.8002 10.1163 25.5352C10.4726 26.1327 10.7988 26.749 11.2113 27.3077C11.4801 27.674 11.7826 28.0127 12.0526 28.3765C12.3226 28.7415 12.5613 29.1365 12.6813 29.574C12.8376 30.1427 12.7763 30.769 12.5063 31.2927C12.3163 31.6615 12.0238 31.9777 11.6688 32.1915C11.3138 32.4052 10.9401 32.5002 10.5251 32.5002C9.86631 32.5002 9.22256 32.1465 8.61006 31.9027C7.36256 31.4052 6.00756 31.2502 4.72131 30.8627C4.32631 30.744 3.93756 30.6027 3.54006 30.494C3.36256 30.4452 3.18381 30.4027 3.01631 30.3265C2.84881 30.2515 2.69256 30.1377 2.60006 29.9802C2.52881 29.8577 2.50006 29.714 2.50006 29.5727C2.50006 29.4302 2.53506 29.2902 2.58381 29.1577C2.68006 28.8915 2.83631 28.6502 2.94131 28.3865C3.11256 27.9565 3.14381 27.4827 3.12006 27.0202C3.09756 26.559 3.02256 26.1002 2.99131 25.639C2.97631 25.4327 2.97131 25.224 3.01131 25.0202C3.05006 24.8177 3.13756 24.619 3.28631 24.4765C3.42381 24.344 3.60506 24.2652 3.79256 24.2265C3.97881 24.1877 4.17131 24.1865 4.36131 24.1902C4.55131 24.194 4.74256 24.2052 4.93256 24.189C5.12256 24.174 5.31381 24.1315 5.47881 24.0365C5.63631 23.9465 5.76506 23.8127 5.87131 23.6665C5.97756 23.5202 6.06381 23.3602 6.15256 23.2015C6.24006 23.044 6.33131 22.8865 6.44756 22.7465C6.56256 22.6065 6.70506 22.4852 6.87256 22.4165Z",
    fill: "url(#paint3_linear_5038_39507)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_5038_39507",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 22,
    width: 11,
    height: 11
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M6.87256 22.4165C7.04506 22.3452 7.23881 22.3315 7.42131 22.3652C7.60506 22.399 7.77881 22.479 7.93256 22.5827C8.24131 22.7927 8.47006 23.0977 8.68881 23.4002C9.19256 24.0927 9.67631 24.8002 10.1163 25.5352C10.4726 26.1327 10.7988 26.749 11.2113 27.3077C11.4801 27.674 11.7826 28.0127 12.0526 28.3765C12.3226 28.7415 12.5613 29.1365 12.6813 29.574C12.8376 30.1427 12.7763 30.769 12.5063 31.2927C12.3163 31.6615 12.0238 31.9777 11.6688 32.1915C11.3138 32.4052 10.9401 32.5002 10.5251 32.5002C9.86631 32.5002 9.22256 32.1465 8.61006 31.9027C7.36256 31.4052 6.00756 31.2502 4.72131 30.8627C4.32631 30.744 3.93756 30.6027 3.54006 30.494C3.36256 30.4452 3.18381 30.4027 3.01631 30.3265C2.84881 30.2515 2.69256 30.1377 2.60006 29.9802C2.52881 29.8577 2.50006 29.714 2.50006 29.5727C2.50006 29.4302 2.53506 29.2902 2.58381 29.1577C2.68006 28.8915 2.83631 28.6502 2.94131 28.3865C3.11256 27.9565 3.14381 27.4827 3.12006 27.0202C3.09756 26.559 3.02256 26.1002 2.99131 25.639C2.97631 25.4327 2.97131 25.224 3.01131 25.0202C3.05006 24.8177 3.13756 24.619 3.28631 24.4765C3.42381 24.344 3.60506 24.2652 3.79256 24.2265C3.97881 24.1877 4.17131 24.1865 4.36131 24.1902C4.55131 24.194 4.74256 24.2052 4.93256 24.189C5.12256 24.174 5.31381 24.1315 5.47881 24.0365C5.63631 23.9465 5.76506 23.8127 5.87131 23.6665C5.97756 23.5202 6.06381 23.3602 6.15256 23.2015C6.24006 23.044 6.33131 22.8865 6.44756 22.7465C6.56256 22.6065 6.70506 22.4852 6.87256 22.4165Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_5038_39507)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_f_5038_39507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.14506 22.7125C7.30131 22.65 7.47881 22.6425 7.64256 22.68C7.80756 22.7175 7.96131 22.7975 8.09381 22.9012C8.36131 23.1075 8.54631 23.3975 8.72506 23.6837C9.15257 24.3762 9.57007 25.0775 9.96507 25.7912C10.2651 26.33 10.5501 26.8787 10.9176 27.3725C11.1613 27.7 11.4401 28.0012 11.6888 28.325C11.9376 28.6487 12.1588 29.0012 12.2688 29.395C12.4113 29.9012 12.3538 30.4625 12.1088 30.9275C11.9313 31.2625 11.6613 31.5475 11.3338 31.7375C11.0076 31.9275 10.6251 32.0225 10.2476 32.005C9.64506 31.9775 9.09381 31.6762 8.52631 31.4725C7.43756 31.0775 6.25881 31.0237 5.14131 30.7162C4.74131 30.6075 4.35131 30.4625 3.95006 30.3612C3.77131 30.3162 3.59006 30.2787 3.42131 30.2075C3.25256 30.1362 3.09381 30.0262 3.00131 29.8675C2.93381 29.7487 2.90631 29.61 2.91006 29.4737C2.91506 29.3375 2.94881 29.2025 2.99756 29.075C3.09506 28.82 3.24756 28.59 3.34506 28.335C3.49381 27.95 3.51256 27.5262 3.48506 27.115C3.45756 26.7037 3.38506 26.295 3.36006 25.8837C3.35006 25.6987 3.34756 25.5125 3.38506 25.3325C3.42256 25.1512 3.50131 24.9762 3.63256 24.8462C3.77506 24.705 3.97006 24.6287 4.16881 24.5975C4.36631 24.5675 4.56756 24.5812 4.76631 24.5987C4.96631 24.6162 5.16631 24.6387 5.36631 24.6275C5.56631 24.615 5.76881 24.5662 5.93381 24.4537C6.08381 24.3525 6.19631 24.2037 6.28256 24.045C6.36881 23.8862 6.43006 23.715 6.49631 23.5475C6.56131 23.3787 6.63256 23.2112 6.73506 23.0612C6.83756 22.9125 6.97632 22.7812 7.14506 22.7125Z",
    fill: "#D99A03"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_5038_39507",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 22,
    width: 11,
    height: 11
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M6.87256 22.4165C7.04506 22.3452 7.23881 22.3315 7.42131 22.3652C7.60506 22.399 7.77881 22.479 7.93256 22.5827C8.24131 22.7927 8.47006 23.0977 8.68881 23.4002C9.19256 24.0927 9.67631 24.8002 10.1163 25.5352C10.4726 26.1327 10.7988 26.749 11.2113 27.3077C11.4801 27.674 11.7826 28.0127 12.0526 28.3765C12.3226 28.7415 12.5613 29.1365 12.6813 29.574C12.8376 30.1427 12.7763 30.769 12.5063 31.2927C12.3163 31.6615 12.0238 31.9777 11.6688 32.1915C11.3138 32.4052 10.9401 32.5002 10.5251 32.5002C9.86631 32.5002 9.22256 32.1465 8.61006 31.9027C7.36256 31.4052 6.00756 31.2502 4.72131 30.8627C4.32631 30.744 3.93756 30.6027 3.54006 30.494C3.36256 30.4452 3.18381 30.4027 3.01631 30.3265C2.84881 30.2515 2.69256 30.1377 2.60006 29.9802C2.52881 29.8577 2.50006 29.714 2.50006 29.5727C2.50006 29.4302 2.53506 29.2902 2.58381 29.1577C2.68006 28.8915 2.83631 28.6502 2.94131 28.3865C3.11256 27.9565 3.14381 27.4827 3.12006 27.0202C3.09756 26.559 3.02256 26.1002 2.99131 25.639C2.97631 25.4327 2.97131 25.224 3.01131 25.0202C3.05006 24.8177 3.13756 24.619 3.28631 24.4765C3.42381 24.344 3.60506 24.2652 3.79256 24.2265C3.97881 24.1877 4.17131 24.1865 4.36131 24.1902C4.55131 24.194 4.74256 24.2052 4.93256 24.189C5.12256 24.174 5.31381 24.1315 5.47881 24.0365C5.63631 23.9465 5.76506 23.8127 5.87131 23.6665C5.97756 23.5202 6.06381 23.3602 6.15256 23.2015C6.24006 23.044 6.33131 22.8865 6.44756 22.7465C6.56256 22.6065 6.70506 22.4852 6.87256 22.4165Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_5038_39507)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_f_5038_39507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.99881 22.3214C7.15131 22.2464 7.33006 22.2314 7.49631 22.2651C7.66256 22.2989 7.81756 22.3801 7.94881 22.4864C8.21006 22.6989 8.37756 23.0026 8.53256 23.3001C8.88756 23.9826 9.22006 24.6801 9.64506 25.3239C9.95506 25.7901 10.3113 26.2239 10.6238 26.6889C11.0476 27.3176 11.3926 28.0101 11.5351 28.7514C11.6301 29.2514 11.6276 29.7901 11.3876 30.2389C11.2288 30.5351 10.9726 30.7776 10.6688 30.9289C10.3663 31.0814 10.0176 31.1426 9.67881 31.1126C9.14506 31.0664 8.66131 30.8039 8.15881 30.6201C7.26756 30.2964 6.30381 30.2176 5.38631 29.9726C5.00006 29.8701 4.62006 29.7364 4.22881 29.6551C4.05506 29.6189 3.87881 29.5926 3.71381 29.5301C3.54881 29.4676 3.39256 29.3639 3.30756 29.2114C3.24881 29.1039 3.22881 28.9789 3.23756 28.8564C3.24631 28.7351 3.28256 28.6164 3.33006 28.5026C3.42631 28.2776 3.56756 28.0701 3.64131 27.8376C3.75131 27.4939 3.70631 27.1226 3.62381 26.7714C3.54256 26.4214 3.42381 26.0776 3.38756 25.7201C3.37131 25.5614 3.37131 25.3989 3.40881 25.2426C3.44506 25.0864 3.51881 24.9364 3.63506 24.8251C3.78506 24.6814 3.99506 24.6089 4.20506 24.5889C4.41381 24.5689 4.62381 24.5964 4.83131 24.6264C5.03881 24.6564 5.24881 24.6889 5.45756 24.6789C5.66756 24.6701 5.88131 24.6151 6.04506 24.4864C6.20756 24.3589 6.31006 24.1701 6.36881 23.9751C6.42756 23.7789 6.44631 23.5751 6.47006 23.3726C6.49381 23.1701 6.52381 22.9651 6.60256 22.7764C6.68131 22.5876 6.81381 22.4139 6.99881 22.3214Z",
    fill: "#F5BD0C"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_5038_39507",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 22,
    width: 11,
    height: 11
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M6.87256 22.4165C7.04506 22.3452 7.23881 22.3315 7.42131 22.3652C7.60506 22.399 7.77881 22.479 7.93256 22.5827C8.24131 22.7927 8.47006 23.0977 8.68881 23.4002C9.19256 24.0927 9.67631 24.8002 10.1163 25.5352C10.4726 26.1327 10.7988 26.749 11.2113 27.3077C11.4801 27.674 11.7826 28.0127 12.0526 28.3765C12.3226 28.7415 12.5613 29.1365 12.6813 29.574C12.8376 30.1427 12.7763 30.769 12.5063 31.2927C12.3163 31.6615 12.0238 31.9777 11.6688 32.1915C11.3138 32.4052 10.9401 32.5002 10.5251 32.5002C9.86631 32.5002 9.22256 32.1465 8.61006 31.9027C7.36256 31.4052 6.00756 31.2502 4.72131 30.8627C4.32631 30.744 3.93756 30.6027 3.54006 30.494C3.36256 30.4452 3.18381 30.4027 3.01631 30.3265C2.84881 30.2515 2.69256 30.1377 2.60006 29.9802C2.52881 29.8577 2.50006 29.714 2.50006 29.5727C2.50006 29.4302 2.53506 29.2902 2.58381 29.1577C2.68006 28.8915 2.83631 28.6502 2.94131 28.3865C3.11256 27.9565 3.14381 27.4827 3.12006 27.0202C3.09756 26.559 3.02256 26.1002 2.99131 25.639C2.97631 25.4327 2.97131 25.224 3.01131 25.0202C3.05006 24.8177 3.13756 24.619 3.28631 24.4765C3.42381 24.344 3.60506 24.2652 3.79256 24.2265C3.97881 24.1877 4.17131 24.1865 4.36131 24.1902C4.55131 24.194 4.74256 24.2052 4.93256 24.189C5.12256 24.174 5.31381 24.1315 5.47881 24.0365C5.63631 23.9465 5.76506 23.8127 5.87131 23.6665C5.97756 23.5202 6.06381 23.3602 6.15256 23.2015C6.24006 23.044 6.33131 22.8865 6.44756 22.7465C6.56256 22.6065 6.70506 22.4852 6.87256 22.4165Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_5038_39507)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_f_5038_39507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.90002 24.0264C9.18127 24.5339 9.35252 25.1164 9.63127 25.6289C9.88752 26.1001 10.1788 26.5851 10.4388 27.0189C10.555 27.2126 10.825 27.5101 11.0975 27.9714C11.345 28.3889 11.595 28.9726 11.735 29.1689C11.655 28.9389 11.49 28.3226 11.2925 27.8839C11.1088 27.4739 10.8938 27.2401 10.7625 27.0189C10.5025 26.5851 10.2213 26.1939 9.95377 25.7801C9.58502 25.2089 9.30377 24.5701 8.90002 24.0264Z",
    fill: "url(#paint4_linear_5038_39507)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_5038_39507",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 0,
    width: 18,
    height: 32
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8688 0.5C15.1188 0.5 14.3663 0.6475 13.6863 1.015C12.9638 1.40375 12.3713 2.02625 12.0075 2.76125C11.6425 3.49625 11.5 4.28125 11.4775 5.14625C11.4363 6.78875 11.515 8.51125 11.6388 10.0725C11.6713 10.5475 11.7313 10.825 11.67 11.3138C11.4675 12.3513 10.56 13.0487 10.075 13.96C9.54128 14.965 9.31628 16.1012 8.91378 17.1663C8.54503 18.14 8.02753 19.0537 7.67878 20.035C7.19003 21.4062 7.04378 22.9137 7.36628 24.3337C7.61253 25.4163 8.12628 26.4312 8.81878 27.3C8.71878 27.48 8.62128 27.6638 8.51878 27.8425C8.19753 28.3962 7.80503 28.9225 7.62253 29.5362C7.53128 29.8425 7.49503 30.17 7.55378 30.485C7.61253 30.8 7.77253 31.1012 8.02253 31.3013C8.18628 31.4312 8.38503 31.5162 8.58878 31.5637C8.79253 31.61 9.00378 31.6213 9.21378 31.6175C10.01 31.6 10.7825 31.3587 11.5525 31.1562C12.01 31.0362 12.47 30.93 12.9313 30.8337C14.5738 30.4975 16.4063 30.6325 17.93 30.8525C18.4463 30.9313 18.9588 31.0325 19.4663 31.1562C20.2613 31.3487 21.0525 31.5938 21.87 31.6175C22.085 31.6238 22.3025 31.6137 22.5125 31.5675C22.7225 31.52 22.9263 31.435 23.0938 31.3013C23.345 31.1012 23.505 30.7987 23.5638 30.4837C23.6225 30.1687 23.5863 29.84 23.4938 29.5325C23.3088 28.9175 22.9125 28.3938 22.585 27.8425C22.455 27.6238 22.335 27.4013 22.2063 27.1825C23.1938 26.0738 23.9888 24.7913 24.4488 23.3825C24.95 21.845 25.0425 20.1887 24.8313 18.585C24.62 16.9812 24.1113 15.4262 23.4425 13.9537C22.6025 12.1087 21.8963 11.4412 21.3838 9.82C20.8313 8.0675 21.2875 5.99375 20.8763 4.405C20.73 3.865 20.4963 3.34875 20.195 2.87625C19.8425 2.3225 19.395 1.8275 18.8638 1.4425C18.0163 0.8275 16.9513 0.5 15.8688 0.5Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_5038_39507)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter12_f_5038_39507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.3375 27.451C27.2875 27.6173 27.21 27.7785 27.1113 27.926C26.8925 28.2498 26.5738 28.4948 26.2563 28.7198C25.715 29.1035 25.15 29.456 24.645 29.8923C24.3075 30.1848 23.9988 30.5135 23.7138 30.8585C23.47 31.1535 23.24 31.4635 22.9613 31.726C22.68 31.991 22.35 32.206 21.9938 32.3223C21.56 32.4635 21.1025 32.4573 20.685 32.3498C20.3925 32.2748 20.1063 32.1448 19.925 31.9085C19.7438 31.6723 19.685 31.3535 19.6638 31.041C19.6263 30.4885 19.6925 29.9248 19.7525 29.3635C19.8025 28.8973 19.8488 28.431 19.8675 27.966C19.9013 27.1198 19.845 26.2823 19.7313 25.4598C19.7113 25.321 19.6913 25.1823 19.7025 25.041C19.7138 24.8985 19.7613 24.751 19.8613 24.641C19.9538 24.5398 20.0825 24.4798 20.21 24.451C20.3375 24.421 20.4675 24.4198 20.5963 24.416C20.9 24.4085 21.2038 24.3898 21.5025 24.4173C21.6913 24.4335 21.8763 24.4685 22.0638 24.486C22.3775 24.516 22.7038 24.501 23.0188 24.4085C23.3575 24.3085 23.68 24.1223 24.025 24.071C24.1663 24.0498 24.3075 24.0523 24.445 24.0723C24.585 24.091 24.725 24.1298 24.8325 24.216C24.915 24.281 24.975 24.3698 25.0213 24.4648C25.0913 24.6073 25.1338 24.7635 25.1588 24.9248C25.18 25.0673 25.1888 25.2135 25.225 25.351C25.285 25.5773 25.4225 25.7698 25.5863 25.926C25.7513 26.0823 25.9425 26.206 26.135 26.3285C26.3263 26.4498 26.5188 26.5698 26.7225 26.6698C26.8188 26.7173 26.9175 26.7598 27.0088 26.8135C27.1013 26.8685 27.1863 26.9348 27.2475 27.0223C27.33 27.141 27.3625 27.2973 27.3375 27.451Z",
    fill: "url(#paint5_linear_5038_39507)"
  })))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1838 28.3652C28.9013 28.7002 28.5088 28.9215 28.1176 29.1214C27.4513 29.4602 26.7601 29.7589 26.1338 30.1677C25.7138 30.4414 25.3263 30.7627 24.9638 31.1089C24.6538 31.4052 24.3601 31.7214 24.0126 31.9727C23.6613 32.2264 23.2563 32.4102 22.8276 32.4739C22.7088 32.4914 22.5901 32.5002 22.4701 32.5002C22.0651 32.5002 21.6601 32.4027 21.2876 32.2402C20.9501 32.094 20.6251 31.8827 20.4301 31.5702C20.2351 31.2552 20.1901 30.8714 20.1901 30.5002C20.1888 29.8464 20.3101 29.1989 20.4238 28.5539C20.5188 28.0177 20.6088 27.4815 20.6676 26.9402C20.7738 25.9577 20.7726 24.9639 20.7026 23.9764C20.6901 23.8114 20.6763 23.6452 20.7013 23.4815C20.7263 23.3177 20.7938 23.1539 20.9188 23.0464C21.0351 22.9464 21.1901 22.9014 21.3438 22.8939C21.4963 22.8852 21.6488 22.9089 21.8001 22.9314C22.1563 22.9839 22.5163 23.0239 22.8651 23.1164C23.0851 23.1739 23.3001 23.2515 23.5188 23.3115C23.8863 23.4102 24.2701 23.4577 24.6463 23.4139C25.0526 23.3664 25.4476 23.2139 25.8563 23.2239C26.0238 23.2277 26.1901 23.2589 26.3501 23.3102C26.5126 23.3614 26.6738 23.4352 26.7938 23.5577C26.8851 23.6502 26.9488 23.7665 26.9963 23.8877C27.0676 24.0677 27.1063 24.2602 27.1226 24.4527C27.1363 24.6239 27.1338 24.7977 27.1663 24.9664C27.2201 25.2427 27.3663 25.4964 27.5463 25.7127C27.7276 25.9302 27.9438 26.1139 28.1601 26.2952C28.3763 26.4764 28.5926 26.6565 28.8251 26.8152C28.9338 26.8902 29.0463 26.9602 29.1501 27.0415C29.2538 27.124 29.3488 27.2189 29.4138 27.3339C29.4701 27.4352 29.5001 27.549 29.5001 27.6652C29.5001 27.7302 29.4913 27.7952 29.4713 27.8602C29.4151 28.039 29.3113 28.2127 29.1838 28.3652Z",
    fill: "url(#paint6_linear_5038_39507)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_5038_39507",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 22,
    width: 10,
    height: 11
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1838 28.3652C28.9013 28.7002 28.5088 28.9215 28.1176 29.1214C27.4513 29.4602 26.7601 29.7589 26.1338 30.1677C25.7138 30.4414 25.3263 30.7627 24.9638 31.1089C24.6538 31.4052 24.3601 31.7214 24.0126 31.9727C23.6613 32.2264 23.2563 32.4102 22.8276 32.4739C22.7088 32.4914 22.5901 32.5002 22.4701 32.5002C22.0651 32.5002 21.6601 32.4027 21.2876 32.2402C20.9501 32.094 20.6251 31.8827 20.4301 31.5702C20.2351 31.2552 20.1901 30.8714 20.1901 30.5002C20.1888 29.8464 20.3101 29.1989 20.4238 28.5539C20.5188 28.0177 20.6088 27.4815 20.6676 26.9402C20.7738 25.9577 20.7726 24.9639 20.7026 23.9764C20.6901 23.8114 20.6763 23.6452 20.7013 23.4815C20.7263 23.3177 20.7938 23.1539 20.9188 23.0464C21.0351 22.9464 21.1901 22.9014 21.3438 22.8939C21.4963 22.8852 21.6488 22.9089 21.8001 22.9314C22.1563 22.9839 22.5163 23.0239 22.8651 23.1164C23.0851 23.1739 23.3001 23.2515 23.5188 23.3115C23.8863 23.4102 24.2701 23.4577 24.6463 23.4139C25.0526 23.3664 25.4476 23.2139 25.8563 23.2239C26.0238 23.2277 26.1901 23.2589 26.3501 23.3102C26.5126 23.3614 26.6738 23.4352 26.7938 23.5577C26.8851 23.6502 26.9488 23.7665 26.9963 23.8877C27.0676 24.0677 27.1063 24.2602 27.1226 24.4527C27.1363 24.6239 27.1338 24.7977 27.1663 24.9664C27.2201 25.2427 27.3663 25.4964 27.5463 25.7127C27.7276 25.9302 27.9438 26.1139 28.1601 26.2952C28.3763 26.4764 28.5926 26.6565 28.8251 26.8152C28.9338 26.8902 29.0463 26.9602 29.1501 27.0415C29.2538 27.124 29.3488 27.2189 29.4138 27.3339C29.4701 27.4352 29.5001 27.549 29.5001 27.6652C29.5001 27.7302 29.4913 27.7952 29.4713 27.8602C29.4151 28.039 29.3113 28.2127 29.1838 28.3652Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_5038_39507)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_f_5038_39507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.1513 27.515C29.085 27.6812 28.9913 27.8375 28.8738 27.9737C28.615 28.2762 28.2575 28.475 27.9013 28.6537C27.2913 28.9587 26.6613 29.2262 26.0888 29.5937C25.7063 29.84 25.3513 30.1287 25.02 30.4412C24.7375 30.7075 24.4688 30.9925 24.1513 31.2175C23.83 31.4462 23.46 31.61 23.07 31.6675C22.595 31.7375 22.105 31.6475 21.6638 31.4587C21.3563 31.3262 21.0588 31.1387 20.88 30.855C20.7025 30.5725 20.6613 30.2275 20.6613 29.8937C20.6588 29.305 20.77 28.7225 20.875 28.1437C20.9625 27.6625 21.045 27.18 21.0975 26.6937C21.1925 25.8087 21.1888 24.9162 21.1288 24.0287C21.1188 23.88 21.1075 23.73 21.13 23.5825C21.1525 23.435 21.2138 23.2887 21.3263 23.1912C21.4325 23.1 21.575 23.06 21.715 23.0537C21.8538 23.0462 21.9925 23.0687 22.1313 23.0887C22.4575 23.1362 22.785 23.1725 23.1038 23.255C23.305 23.3075 23.5013 23.3775 23.7013 23.43C24.0363 23.52 24.3875 23.5625 24.7313 23.5225C25.1025 23.48 25.4625 23.3425 25.835 23.3512C25.9888 23.355 26.14 23.3837 26.2863 23.4287C26.435 23.475 26.5825 23.5412 26.6925 23.6512C26.775 23.735 26.8313 23.84 26.8775 23.9487C26.9438 24.11 26.9888 24.2825 26.9913 24.4575C26.995 24.64 26.9563 24.8225 26.98 25.0037C27 25.15 27.0625 25.2887 27.1425 25.4137C27.2213 25.5387 27.3175 25.6525 27.4138 25.765C27.5988 25.9837 27.7838 26.2062 28.0163 26.3737C28.28 26.565 28.5938 26.6775 28.8663 26.855C28.9475 26.9087 29.0263 26.9687 29.0838 27.0475C29.1813 27.18 29.2063 27.36 29.1513 27.515Z",
    fill: "#CD8907"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_5038_39507",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 22,
    width: 10,
    height: 11
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1838 28.3652C28.9013 28.7002 28.5088 28.9215 28.1176 29.1214C27.4513 29.4602 26.7601 29.7589 26.1338 30.1677C25.7138 30.4414 25.3263 30.7627 24.9638 31.1089C24.6538 31.4052 24.3601 31.7214 24.0126 31.9727C23.6613 32.2264 23.2563 32.4102 22.8276 32.4739C22.7088 32.4914 22.5901 32.5002 22.4701 32.5002C22.0651 32.5002 21.6601 32.4027 21.2876 32.2402C20.9501 32.094 20.6251 31.8827 20.4301 31.5702C20.2351 31.2552 20.1901 30.8714 20.1901 30.5002C20.1888 29.8464 20.3101 29.1989 20.4238 28.5539C20.5188 28.0177 20.6088 27.4815 20.6676 26.9402C20.7738 25.9577 20.7726 24.9639 20.7026 23.9764C20.6901 23.8114 20.6763 23.6452 20.7013 23.4815C20.7263 23.3177 20.7938 23.1539 20.9188 23.0464C21.0351 22.9464 21.1901 22.9014 21.3438 22.8939C21.4963 22.8852 21.6488 22.9089 21.8001 22.9314C22.1563 22.9839 22.5163 23.0239 22.8651 23.1164C23.0851 23.1739 23.3001 23.2515 23.5188 23.3115C23.8863 23.4102 24.2701 23.4577 24.6463 23.4139C25.0526 23.3664 25.4476 23.2139 25.8563 23.2239C26.0238 23.2277 26.1901 23.2589 26.3501 23.3102C26.5126 23.3614 26.6738 23.4352 26.7938 23.5577C26.8851 23.6502 26.9488 23.7665 26.9963 23.8877C27.0676 24.0677 27.1063 24.2602 27.1226 24.4527C27.1363 24.6239 27.1338 24.7977 27.1663 24.9664C27.2201 25.2427 27.3663 25.4964 27.5463 25.7127C27.7276 25.9302 27.9438 26.1139 28.1601 26.2952C28.3763 26.4764 28.5926 26.6565 28.8251 26.8152C28.9338 26.8902 29.0463 26.9602 29.1501 27.0415C29.2538 27.124 29.3488 27.2189 29.4138 27.3339C29.4701 27.4352 29.5001 27.549 29.5001 27.6652C29.5001 27.7302 29.4913 27.7952 29.4713 27.8602C29.4151 28.039 29.3113 28.2127 29.1838 28.3652Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_5038_39507)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_f_5038_39507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.1138 27.3263C29.0388 27.4951 28.9426 27.6513 28.8288 27.7901C28.5638 28.1126 28.2051 28.3338 27.8288 28.4763C27.2076 28.7113 26.5301 28.7426 25.9213 29.0101C25.5501 29.1726 25.2151 29.4176 24.8763 29.6501C24.6038 29.8363 24.3238 30.0176 24.0238 30.1476C23.6838 30.2963 23.3238 30.3788 22.9613 30.4376C22.7313 30.4738 22.4976 30.5013 22.2651 30.4888C22.0326 30.4763 21.8001 30.4213 21.5938 30.3026C21.4388 30.2126 21.2988 30.0838 21.2151 29.9151C21.1238 29.7288 21.1076 29.5101 21.1088 29.2976C21.1151 28.7351 21.2363 28.1776 21.2326 27.6138C21.2288 27.1226 21.1313 26.6388 21.1038 26.1488C21.0501 25.2063 21.2526 24.2488 21.0738 23.3251C21.0463 23.1763 21.0076 23.0288 21.0088 22.8776C21.0101 22.8026 21.0213 22.7263 21.0476 22.6563C21.0751 22.5876 21.1176 22.5238 21.1738 22.4788C21.2226 22.4426 21.2788 22.4201 21.3376 22.4088C21.3951 22.3988 21.4551 22.4013 21.5138 22.4101C21.6301 22.4288 21.7413 22.4738 21.8551 22.5076C22.1801 22.6051 22.5238 22.6026 22.8551 22.6763C23.0626 22.7213 23.2626 22.7976 23.4688 22.8526C23.8126 22.9476 24.1726 22.9876 24.5263 22.9463C24.9063 22.9013 25.2776 22.7638 25.6601 22.7738C25.8176 22.7776 25.9726 22.8063 26.1238 22.8513C26.2751 22.8963 26.4263 22.9601 26.5413 23.0763C26.6226 23.1601 26.6826 23.2663 26.7301 23.3763C26.8013 23.5376 26.8501 23.7126 26.8488 23.8901C26.8476 23.9826 26.8338 24.0738 26.8251 24.1663C26.8176 24.2588 26.8151 24.3526 26.8363 24.4413C26.8588 24.5313 26.9051 24.6126 26.9576 24.6863C27.0101 24.7601 27.0701 24.8263 27.1251 24.8988C27.2776 25.1001 27.3876 25.3351 27.5063 25.5613C27.6251 25.7876 27.7588 26.0113 27.9476 26.1751C28.2038 26.3963 28.5351 26.4851 28.8213 26.6613C28.9051 26.7126 28.9851 26.7726 29.0438 26.8551C29.0913 26.9201 29.1226 26.9988 29.1351 27.0813C29.1463 27.1626 29.1388 27.2488 29.1138 27.3263Z",
    fill: "#F5C021"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_5038_39507",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 22,
    width: 10,
    height: 11
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1838 28.3652C28.9013 28.7002 28.5088 28.9215 28.1176 29.1214C27.4513 29.4602 26.7601 29.7589 26.1338 30.1677C25.7138 30.4414 25.3263 30.7627 24.9638 31.1089C24.6538 31.4052 24.3601 31.7214 24.0126 31.9727C23.6613 32.2264 23.2563 32.4102 22.8276 32.4739C22.7088 32.4914 22.5901 32.5002 22.4701 32.5002C22.0651 32.5002 21.6601 32.4027 21.2876 32.2402C20.9501 32.094 20.6251 31.8827 20.4301 31.5702C20.2351 31.2552 20.1901 30.8714 20.1901 30.5002C20.1888 29.8464 20.3101 29.1989 20.4238 28.5539C20.5188 28.0177 20.6088 27.4815 20.6676 26.9402C20.7738 25.9577 20.7726 24.9639 20.7026 23.9764C20.6901 23.8114 20.6763 23.6452 20.7013 23.4815C20.7263 23.3177 20.7938 23.1539 20.9188 23.0464C21.0351 22.9464 21.1901 22.9014 21.3438 22.8939C21.4963 22.8852 21.6488 22.9089 21.8001 22.9314C22.1563 22.9839 22.5163 23.0239 22.8651 23.1164C23.0851 23.1739 23.3001 23.2515 23.5188 23.3115C23.8863 23.4102 24.2701 23.4577 24.6463 23.4139C25.0526 23.3664 25.4476 23.2139 25.8563 23.2239C26.0238 23.2277 26.1901 23.2589 26.3501 23.3102C26.5126 23.3614 26.6738 23.4352 26.7938 23.5577C26.8851 23.6502 26.9488 23.7665 26.9963 23.8877C27.0676 24.0677 27.1063 24.2602 27.1226 24.4527C27.1363 24.6239 27.1338 24.7977 27.1663 24.9664C27.2201 25.2427 27.3663 25.4964 27.5463 25.7127C27.7276 25.9302 27.9438 26.1139 28.1601 26.2952C28.3763 26.4764 28.5926 26.6565 28.8251 26.8152C28.9338 26.8902 29.0463 26.9602 29.1501 27.0415C29.2538 27.124 29.3488 27.2189 29.4138 27.3339C29.4701 27.4352 29.5001 27.549 29.5001 27.6652C29.5001 27.7302 29.4913 27.7952 29.4713 27.8602C29.4151 28.039 29.3113 28.2127 29.1838 28.3652Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_5038_39507)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter15_f_5038_39507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.0101 23.1979C21.3626 23.1029 21.6626 23.3704 21.9188 23.5717C22.0838 23.7129 22.3238 23.6779 22.5263 23.6842C22.8626 23.6729 23.1963 23.7404 23.5326 23.6992C24.1951 23.6429 24.8438 23.4804 25.5088 23.4529C25.8263 23.4329 26.1838 23.4142 26.4576 23.5992C26.5688 23.6767 26.7326 24.0029 26.8413 23.8804C26.7963 23.5379 26.5426 23.2067 26.2026 23.1154C25.9351 23.0729 25.6651 23.1467 25.3951 23.1229C24.5963 23.1042 23.8013 22.9554 23.0001 22.9979C22.4426 23.0029 21.8863 22.9767 21.3288 22.9554C21.1101 22.9104 21.0326 23.1042 20.9138 23.1792C20.9451 23.2029 20.9563 23.2104 21.0101 23.1979Z",
    fill: "url(#paint7_linear_5038_39507)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_5038_39507",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 22,
    width: 10,
    height: 11
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1838 28.3652C28.9013 28.7002 28.5088 28.9215 28.1176 29.1214C27.4513 29.4602 26.7601 29.7589 26.1338 30.1677C25.7138 30.4414 25.3263 30.7627 24.9638 31.1089C24.6538 31.4052 24.3601 31.7214 24.0126 31.9727C23.6613 32.2264 23.2563 32.4102 22.8276 32.4739C22.7088 32.4914 22.5901 32.5002 22.4701 32.5002C22.0651 32.5002 21.6601 32.4027 21.2876 32.2402C20.9501 32.094 20.6251 31.8827 20.4301 31.5702C20.2351 31.2552 20.1901 30.8714 20.1901 30.5002C20.1888 29.8464 20.3101 29.1989 20.4238 28.5539C20.5188 28.0177 20.6088 27.4815 20.6676 26.9402C20.7738 25.9577 20.7726 24.9639 20.7026 23.9764C20.6901 23.8114 20.6763 23.6452 20.7013 23.4815C20.7263 23.3177 20.7938 23.1539 20.9188 23.0464C21.0351 22.9464 21.1901 22.9014 21.3438 22.8939C21.4963 22.8852 21.6488 22.9089 21.8001 22.9314C22.1563 22.9839 22.5163 23.0239 22.8651 23.1164C23.0851 23.1739 23.3001 23.2515 23.5188 23.3115C23.8863 23.4102 24.2701 23.4577 24.6463 23.4139C25.0526 23.3664 25.4476 23.2139 25.8563 23.2239C26.0238 23.2277 26.1901 23.2589 26.3501 23.3102C26.5126 23.3614 26.6738 23.4352 26.7938 23.5577C26.8851 23.6502 26.9488 23.7665 26.9963 23.8877C27.0676 24.0677 27.1063 24.2602 27.1226 24.4527C27.1363 24.6239 27.1338 24.7977 27.1663 24.9664C27.2201 25.2427 27.3663 25.4964 27.5463 25.7127C27.7276 25.9302 27.9438 26.1139 28.1601 26.2952C28.3763 26.4764 28.5926 26.6565 28.8251 26.8152C28.9338 26.8902 29.0463 26.9602 29.1501 27.0415C29.2538 27.124 29.3488 27.2189 29.4138 27.3339C29.4701 27.4352 29.5001 27.549 29.5001 27.6652C29.5001 27.7302 29.4913 27.7952 29.4713 27.8602C29.4151 28.039 29.3113 28.2127 29.1838 28.3652Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_5038_39507)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.35,
    filter: "url(#filter16_f_5038_39507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.6863 23.9515C25.6263 23.8327 25.5163 23.744 25.3926 23.6927C25.2701 23.6415 25.1351 23.624 25.0013 23.6252C24.7351 23.6277 24.4701 23.6965 24.2038 23.674C23.9801 23.654 23.7676 23.5702 23.5488 23.5165C23.3226 23.4615 23.0826 23.4402 22.8588 23.5015C22.6188 23.5665 22.4076 23.7277 22.2751 23.9377C22.1576 24.1227 22.1026 24.3415 22.0851 24.5602C22.0676 24.779 22.0863 24.9977 22.1088 25.2165C22.1238 25.374 22.1426 25.5315 22.1801 25.6852C22.2188 25.839 22.2776 25.989 22.3701 26.1177C22.5038 26.3027 22.7026 26.4352 22.9163 26.514C23.2663 26.6427 23.6638 26.6365 24.0076 26.4952C24.6176 26.2302 25.1338 25.7552 25.4476 25.1702C25.5613 24.9602 25.6488 24.7365 25.7051 24.5065C25.7276 24.414 25.7451 24.3202 25.7451 24.2252C25.7463 24.1315 25.7301 24.0352 25.6863 23.9515Z",
    fill: "url(#paint8_radial_5038_39507)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_5038_39507",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 22,
    width: 10,
    height: 11
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1838 28.3652C28.9013 28.7002 28.5088 28.9215 28.1176 29.1214C27.4513 29.4602 26.7601 29.7589 26.1338 30.1677C25.7138 30.4414 25.3263 30.7627 24.9638 31.1089C24.6538 31.4052 24.3601 31.7214 24.0126 31.9727C23.6613 32.2264 23.2563 32.4102 22.8276 32.4739C22.7088 32.4914 22.5901 32.5002 22.4701 32.5002C22.0651 32.5002 21.6601 32.4027 21.2876 32.2402C20.9501 32.094 20.6251 31.8827 20.4301 31.5702C20.2351 31.2552 20.1901 30.8714 20.1901 30.5002C20.1888 29.8464 20.3101 29.1989 20.4238 28.5539C20.5188 28.0177 20.6088 27.4815 20.6676 26.9402C20.7738 25.9577 20.7726 24.9639 20.7026 23.9764C20.6901 23.8114 20.6763 23.6452 20.7013 23.4815C20.7263 23.3177 20.7938 23.1539 20.9188 23.0464C21.0351 22.9464 21.1901 22.9014 21.3438 22.8939C21.4963 22.8852 21.6488 22.9089 21.8001 22.9314C22.1563 22.9839 22.5163 23.0239 22.8651 23.1164C23.0851 23.1739 23.3001 23.2515 23.5188 23.3115C23.8863 23.4102 24.2701 23.4577 24.6463 23.4139C25.0526 23.3664 25.4476 23.2139 25.8563 23.2239C26.0238 23.2277 26.1901 23.2589 26.3501 23.3102C26.5126 23.3614 26.6738 23.4352 26.7938 23.5577C26.8851 23.6502 26.9488 23.7665 26.9963 23.8877C27.0676 24.0677 27.1063 24.2602 27.1226 24.4527C27.1363 24.6239 27.1338 24.7977 27.1663 24.9664C27.2201 25.2427 27.3663 25.4964 27.5463 25.7127C27.7276 25.9302 27.9438 26.1139 28.1601 26.2952C28.3763 26.4764 28.5926 26.6565 28.8251 26.8152C28.9338 26.8902 29.0463 26.9602 29.1501 27.0415C29.2538 27.124 29.3488 27.2189 29.4138 27.3339C29.4701 27.4352 29.5001 27.549 29.5001 27.6652C29.5001 27.7302 29.4913 27.7952 29.4713 27.8602C29.4151 28.039 29.3113 28.2127 29.1838 28.3652Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_5038_39507)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.35,
    filter: "url(#filter17_f_5038_39507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.6863 23.6113C25.6263 23.5251 25.5163 23.4613 25.3926 23.4238C25.2701 23.3863 25.1351 23.3751 25.0013 23.3751C24.7351 23.3776 24.4701 23.4276 24.2038 23.4101C23.9801 23.3963 23.7676 23.3351 23.5488 23.2976C23.3226 23.2576 23.0826 23.2413 22.8588 23.2863C22.6188 23.3326 22.4076 23.4488 22.2751 23.6013C22.1576 23.7351 22.1026 23.8938 22.0851 24.0513C22.0676 24.2088 22.0863 24.3676 22.1088 24.5251C22.1238 24.6388 22.1426 24.7538 22.1801 24.8651C22.2188 24.9763 22.2776 25.0851 22.3701 25.1776C22.5038 25.3113 22.7026 25.4063 22.9163 25.4638C23.2663 25.5576 23.6638 25.5526 24.0076 25.4501C24.6176 25.2588 25.1338 24.9151 25.4476 24.4926C25.5613 24.3401 25.6488 24.1788 25.7051 24.0126C25.7276 23.9451 25.7451 23.8776 25.7451 23.8101C25.7463 23.7413 25.7301 23.6713 25.6863 23.6113Z",
    fill: "url(#paint9_radial_5038_39507)"
  })))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1938 22.8401C26.1501 22.7213 26.0726 22.6163 25.9788 22.5313C25.8851 22.4463 25.7738 22.3813 25.6576 22.3313C25.4251 22.2326 25.1713 22.1951 24.9213 22.1488C24.6876 22.1051 24.4538 22.0513 24.2188 22.0113C23.9738 21.9701 23.7213 21.9426 23.4788 21.9976C23.2676 22.0451 23.0713 22.1551 22.9113 22.3013C22.7513 22.4476 22.6263 22.6301 22.5363 22.8276C22.3776 23.1763 22.3276 23.5676 22.3576 23.9488C22.3801 24.2326 22.4526 24.5251 22.6388 24.7388C22.7901 24.9126 23.0038 25.0213 23.2238 25.0863C23.6038 25.1988 24.0176 25.1926 24.3938 25.0701C25.0151 24.8613 25.5651 24.4476 25.9376 23.9088C26.0601 23.7301 26.1651 23.5363 26.2126 23.3263C26.2488 23.1663 26.2501 22.9938 26.1938 22.8401Z",
    fill: "#020204"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_5038_39507",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 21,
    width: 5,
    height: 5
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1938 22.8401C26.1501 22.7213 26.0726 22.6163 25.9788 22.5313C25.8851 22.4463 25.7738 22.3813 25.6576 22.3313C25.4251 22.2326 25.1713 22.1951 24.9213 22.1488C24.6876 22.1051 24.4538 22.0513 24.2188 22.0113C23.9738 21.9701 23.7213 21.9426 23.4788 21.9976C23.2676 22.0451 23.0713 22.1551 22.9113 22.3013C22.7513 22.4476 22.6263 22.6301 22.5363 22.8276C22.3776 23.1763 22.3276 23.5676 22.3576 23.9488C22.3801 24.2326 22.4526 24.5251 22.6388 24.7388C22.7901 24.9126 23.0038 25.0213 23.2238 25.0863C23.6038 25.1988 24.0176 25.1926 24.3938 25.0701C25.0151 24.8613 25.5651 24.4476 25.9376 23.9088C26.0601 23.7301 26.1651 23.5363 26.2126 23.3263C26.2488 23.1663 26.2501 22.9938 26.1938 22.8401Z",
    fill: "white"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_5038_39507)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter18_f_5038_39507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.6113 21.8836C23.5526 21.8874 23.4951 21.8936 23.4363 21.9049C23.0626 21.9711 22.7201 22.2074 22.5276 22.5336C22.3913 22.7649 22.3301 23.0374 22.3488 23.3049C22.3576 23.1174 22.4063 22.9336 22.4976 22.7699C22.6513 22.4911 22.9313 22.2811 23.2451 22.2236C23.4376 22.1886 23.6363 22.2099 23.8301 22.2336C24.0176 22.2574 24.2051 22.2824 24.3888 22.3211C24.6738 22.3836 24.9551 22.4786 25.1938 22.6449C25.2488 22.6836 25.3013 22.7274 25.3451 22.7799C25.3888 22.8311 25.4226 22.8911 25.4363 22.9574C25.4551 23.0549 25.4276 23.1574 25.3788 23.2436C25.3301 23.3311 25.2638 23.4061 25.1938 23.4761C25.1363 23.5336 25.0763 23.5874 25.0151 23.6411C25.2913 23.5874 25.5701 23.5124 25.8001 23.3524C25.8963 23.2836 25.9851 23.2024 26.0426 23.0999C26.1001 22.9961 26.1238 22.8711 26.0963 22.7561C26.0763 22.6786 26.0338 22.6074 25.9813 22.5474C25.9288 22.4874 25.8651 22.4386 25.8001 22.3924C25.5113 22.1899 25.1738 22.0611 24.8238 22.0186C24.5988 21.9774 24.3726 21.9424 24.1463 21.9149C23.9701 21.8924 23.7888 21.8736 23.6113 21.8836Z",
    fill: "url(#paint10_radial_5038_39507)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask19_5038_39507",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 21,
    width: 5,
    height: 5
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1938 22.8401C26.1501 22.7213 26.0726 22.6163 25.9788 22.5313C25.8851 22.4463 25.7738 22.3813 25.6576 22.3313C25.4251 22.2326 25.1713 22.1951 24.9213 22.1488C24.6876 22.1051 24.4538 22.0513 24.2188 22.0113C23.9738 21.9701 23.7213 21.9426 23.4788 21.9976C23.2676 22.0451 23.0713 22.1551 22.9113 22.3013C22.7513 22.4476 22.6263 22.6301 22.5363 22.8276C22.3776 23.1763 22.3276 23.5676 22.3576 23.9488C22.3801 24.2326 22.4526 24.5251 22.6388 24.7388C22.7901 24.9126 23.0038 25.0213 23.2238 25.0863C23.6038 25.1988 24.0176 25.1926 24.3938 25.0701C25.0151 24.8613 25.5651 24.4476 25.9376 23.9088C26.0601 23.7301 26.1651 23.5363 26.2126 23.3263C26.2488 23.1663 26.2501 22.9938 26.1938 22.8401Z",
    fill: "white"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_5038_39507)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter19_f_5038_39507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.6113 21.8836C23.5526 21.8874 23.4951 21.8936 23.4363 21.9049C23.0626 21.9711 22.7201 22.2074 22.5276 22.5336C22.3913 22.7649 22.3301 23.0374 22.3488 23.3049C22.3576 23.1174 22.4063 22.9336 22.4976 22.7699C22.6513 22.4911 22.9313 22.2811 23.2451 22.2236C23.4376 22.1886 23.6363 22.2099 23.8301 22.2336C24.0176 22.2574 24.2051 22.2824 24.3888 22.3211C24.6738 22.3836 24.9551 22.4786 25.1938 22.6449C25.2488 22.6836 25.3013 22.7274 25.3451 22.7799C25.3888 22.8311 25.4226 22.8911 25.4363 22.9574C25.4551 23.0549 25.4276 23.1574 25.3788 23.2436C25.3301 23.3311 25.2638 23.4061 25.1938 23.4761C25.1363 23.5336 25.0763 23.5874 25.0151 23.6411C25.2913 23.5874 25.5701 23.5124 25.8001 23.3524C25.8963 23.2836 25.9851 23.2024 26.0426 23.0999C26.1001 22.9961 26.1238 22.8711 26.0963 22.7561C26.0763 22.6786 26.0338 22.6074 25.9813 22.5474C25.9288 22.4874 25.8651 22.4386 25.8001 22.3924C25.5113 22.1899 25.1738 22.0611 24.8238 22.0186C24.5988 21.9774 24.3726 21.9424 24.1463 21.9149C23.9701 21.8924 23.7888 21.8736 23.6113 21.8836Z",
    fill: "url(#paint11_linear_5038_39507)"
  })))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0563 5.28515C12.865 5.29515 12.6813 5.3839 12.5413 5.51515C12.4 5.6464 12.3013 5.8189 12.24 6.00015C12.1188 6.36515 12.1463 6.76015 12.1738 7.1439C12.1988 7.49015 12.225 7.8439 12.355 8.1664C12.42 8.3289 12.5113 8.48015 12.6325 8.60515C12.7538 8.7289 12.9075 8.82515 13.0763 8.8664C13.2338 8.9064 13.4038 8.8989 13.5588 8.85015C13.715 8.80015 13.8563 8.7114 13.9738 8.59765C14.1438 8.4314 14.2575 8.2139 14.3238 7.98515C14.39 7.7564 14.4088 7.5164 14.405 7.27765C14.4 6.98015 14.3613 6.6814 14.2688 6.3989C14.175 6.1164 14.0263 5.8489 13.8188 5.63515C13.7188 5.5314 13.6038 5.4414 13.475 5.37765C13.345 5.3139 13.2 5.27765 13.0563 5.28515Z",
    fill: "url(#paint12_radial_5038_39507)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5938 6.87347C12.5538 7.11597 12.5526 7.36972 12.6351 7.59972C12.6901 7.75222 12.7813 7.89097 12.8913 8.00972C12.9626 8.08722 13.0451 8.15722 13.1401 8.20347C13.2363 8.24972 13.3463 8.26847 13.4501 8.24347C13.5451 8.21972 13.6276 8.15847 13.6888 8.08222C13.7501 8.00597 13.7913 7.91472 13.8201 7.82097C13.9063 7.54472 13.8926 7.24347 13.8063 6.96722C13.7451 6.76597 13.6413 6.57222 13.4813 6.43722C13.4038 6.37222 13.3138 6.32097 13.2163 6.29847C13.1188 6.27472 13.0126 6.28097 12.9213 6.32222C12.8201 6.36847 12.7413 6.45597 12.6901 6.55472C12.6388 6.65347 12.6126 6.76347 12.5938 6.87347Z",
    fill: "#020204"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask20_5038_39507",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 6,
    width: 2,
    height: 3
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5938 6.87347C12.5538 7.11597 12.5526 7.36972 12.6351 7.59972C12.6901 7.75222 12.7813 7.89097 12.8913 8.00972C12.9626 8.08722 13.0451 8.15722 13.1401 8.20347C13.2363 8.24972 13.3463 8.26847 13.4501 8.24347C13.5451 8.21972 13.6276 8.15847 13.6888 8.08222C13.7501 8.00597 13.7913 7.91472 13.8201 7.82097C13.9063 7.54472 13.8926 7.24347 13.8063 6.96722C13.7451 6.76597 13.6413 6.57222 13.4813 6.43722C13.4038 6.37222 13.3138 6.32097 13.2163 6.29847C13.1188 6.27472 13.0126 6.28097 12.9213 6.32222C12.8201 6.36847 12.7413 6.45597 12.6901 6.55472C12.6388 6.65347 12.6126 6.76347 12.5938 6.87347Z",
    fill: "white"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_5038_39507)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter20_f_5038_39507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.1051 6.69855C13.1313 6.7673 13.2188 6.7923 13.2676 6.8473C13.3138 6.8998 13.3626 6.95605 13.3888 7.0223C13.4376 7.14855 13.3401 7.33605 13.4426 7.42605C13.4738 7.45355 13.5388 7.4548 13.5701 7.42605C13.6938 7.31355 13.6663 7.0873 13.6176 6.9273C13.5726 6.78355 13.4638 6.64605 13.3288 6.5773C13.2663 6.5448 13.1726 6.51855 13.1188 6.56355C13.0851 6.59355 13.0888 6.65605 13.1051 6.69855Z",
    fill: "url(#paint13_linear_5038_39507)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask21_5038_39507",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 5,
    width: 3,
    height: 4
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0563 5.28515C12.865 5.29515 12.6813 5.3839 12.5413 5.51515C12.4 5.6464 12.3013 5.8189 12.24 6.00015C12.1188 6.36515 12.1463 6.76015 12.1738 7.1439C12.1988 7.49015 12.225 7.8439 12.355 8.1664C12.42 8.3289 12.5113 8.48015 12.6325 8.60515C12.7538 8.7289 12.9075 8.82515 13.0763 8.8664C13.2338 8.9064 13.4038 8.8989 13.5588 8.85015C13.715 8.80015 13.8563 8.7114 13.9738 8.59765C14.1438 8.4314 14.2575 8.2139 14.3238 7.98515C14.39 7.7564 14.4088 7.5164 14.405 7.27765C14.4 6.98015 14.3613 6.6814 14.2688 6.3989C14.175 6.1164 14.0263 5.8489 13.8188 5.63515C13.7188 5.5314 13.6038 5.4414 13.475 5.37765C13.345 5.3139 13.2 5.27765 13.0563 5.28515Z",
    fill: "white"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_5038_39507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6425 6.05744C12.9325 5.88494 13.2838 5.84494 13.62 5.87619C13.955 5.90869 14.2788 6.00619 14.6038 6.09494C14.8425 6.15994 15.0838 6.21994 15.3075 6.32494C15.53 6.42994 15.7375 6.58494 15.8613 6.79994C15.8813 6.83369 15.8975 6.86994 15.9188 6.90369C15.94 6.93744 15.965 6.96869 15.9963 6.99244C16.0275 7.01619 16.0675 7.03244 16.1063 7.02994C16.1263 7.02869 16.1463 7.02369 16.1625 7.01369C16.18 7.00369 16.195 6.98869 16.2038 6.97119C16.2138 6.95119 16.2175 6.92744 16.2163 6.90494C16.215 6.88244 16.21 6.85994 16.2038 6.83744C16.1225 6.54119 15.93 6.28994 15.785 6.01869C15.6975 5.85619 15.625 5.68619 15.5375 5.52369C15.2338 4.96744 14.735 4.53119 14.1688 4.24744C13.6025 3.96369 12.97 3.82744 12.3375 3.79119C11.605 3.74744 10.8713 3.83494 10.1488 3.96244C9.83502 4.01744 9.51627 4.08244 9.24002 4.23869C9.10127 4.31619 8.97377 4.41619 8.87502 4.54119C8.77502 4.66494 8.70502 4.81369 8.68127 4.97119C8.66002 5.12369 8.68252 5.27994 8.73627 5.42369C8.78877 5.56744 8.87127 5.69869 8.96877 5.81744C9.16127 6.05619 9.41002 6.24119 9.63877 6.44619C9.86752 6.64994 10.0788 6.87619 10.335 7.04494C10.4625 7.12994 10.6013 7.19994 10.7488 7.24119C10.8963 7.28244 11.0538 7.29369 11.2038 7.26244C11.3588 7.23119 11.5038 7.15494 11.63 7.05744C11.7563 6.96119 11.865 6.84494 11.9688 6.72494C12.1763 6.48369 12.37 6.21994 12.6425 6.05744Z",
    fill: "url(#paint14_radial_5038_39507)"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter21_f_5038_39507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8463 5.07121C14.1163 5.32371 14.3163 5.63621 14.4525 5.96621C14.3925 5.60246 14.2988 5.30871 14.0613 5.07121C13.9163 4.93496 13.75 4.81496 13.5638 4.73121C13.3988 4.65746 13.2175 4.61121 13.1125 4.60996C13.0088 4.60746 12.9838 4.60996 12.9625 4.61121C12.94 4.61246 12.9238 4.61246 12.9913 4.62121C13.0588 4.62871 13.21 4.66996 13.3725 4.74246C13.535 4.81496 13.7 4.93496 13.8463 5.07121Z",
    fill: "url(#paint15_linear_5038_39507)"
  }))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4513 5.28473C16.1525 5.49098 15.9013 5.77723 15.7788 6.11973C15.6238 6.55098 15.6825 7.03348 15.8325 7.46598C15.985 7.90973 16.2413 8.33223 16.6275 8.59848C16.82 8.73223 17.0438 8.82348 17.2763 8.85098C17.51 8.87848 17.7513 8.83973 17.96 8.73223C18.2125 8.59973 18.4063 8.36848 18.5263 8.10973C18.6463 7.84973 18.6975 7.56348 18.7138 7.27723C18.7338 6.91473 18.6988 6.54473 18.5788 6.20098C18.4488 5.82723 18.2138 5.48223 17.8813 5.26723C17.7163 5.15973 17.5275 5.08598 17.3313 5.05848C17.135 5.03098 16.9325 5.05223 16.7475 5.12348C16.6425 5.16473 16.545 5.22098 16.4513 5.28473Z",
    fill: "url(#paint16_radial_5038_39507)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1426 6.19011C17.0301 6.19761 16.9201 6.23636 16.8238 6.29636C16.7288 6.35636 16.6476 6.43761 16.5838 6.53136C16.4551 6.71761 16.3988 6.94511 16.3901 7.17136C16.3838 7.34011 16.4026 7.51136 16.4588 7.67136C16.5151 7.83136 16.6088 7.98011 16.7401 8.08761C16.8738 8.19886 17.0426 8.26511 17.2163 8.27386C17.3901 8.28136 17.5651 8.23136 17.7076 8.13261C17.8213 8.05386 17.9126 7.94511 17.9776 7.82261C18.0426 7.70136 18.0826 7.56636 18.1001 7.42886C18.1313 7.18761 18.0963 6.93511 17.9838 6.71761C17.8726 6.50011 17.6826 6.32136 17.4538 6.23761C17.3538 6.20136 17.2476 6.18261 17.1426 6.19011Z",
    fill: "#020204"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask22_5038_39507",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 6,
    width: 3,
    height: 3
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1426 6.19011C17.0301 6.19761 16.9201 6.23636 16.8238 6.29636C16.7288 6.35636 16.6476 6.43761 16.5838 6.53136C16.4551 6.71761 16.3988 6.94511 16.3901 7.17136C16.3838 7.34011 16.4026 7.51136 16.4588 7.67136C16.5151 7.83136 16.6088 7.98011 16.7401 8.08761C16.8738 8.19886 17.0426 8.26511 17.2163 8.27386C17.3901 8.28136 17.5651 8.23136 17.7076 8.13261C17.8213 8.05386 17.9126 7.94511 17.9776 7.82261C18.0426 7.70136 18.0826 7.56636 18.1001 7.42886C18.1313 7.18761 18.0963 6.93511 17.9838 6.71761C17.8726 6.50011 17.6826 6.32136 17.4538 6.23761C17.3538 6.20136 17.2476 6.18261 17.1426 6.19011Z",
    fill: "white"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_5038_39507)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter22_f_5038_39507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8388 7.17031C17.9638 7.04531 17.7501 6.71406 17.5826 6.57781C17.4614 6.48031 17.1101 6.37656 17.1251 6.48406C17.1401 6.59031 17.2989 6.72781 17.4039 6.83281C17.5351 6.96156 17.7788 7.23031 17.8388 7.17031Z",
    fill: "url(#paint17_linear_5038_39507)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask23_5038_39507",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 5,
    width: 4,
    height: 4
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4513 5.28473C16.1525 5.49098 15.9013 5.77723 15.7788 6.11973C15.6238 6.55098 15.6825 7.03348 15.8325 7.46598C15.985 7.90973 16.2413 8.33223 16.6275 8.59848C16.82 8.73223 17.0438 8.82348 17.2763 8.85098C17.51 8.87848 17.7513 8.83973 17.96 8.73223C18.2125 8.59973 18.4063 8.36848 18.5263 8.10973C18.6463 7.84973 18.6975 7.56348 18.7138 7.27723C18.7338 6.91473 18.6988 6.54473 18.5788 6.20098C18.4488 5.82723 18.2138 5.48223 17.8813 5.26723C17.7163 5.15973 17.5275 5.08598 17.3313 5.05848C17.135 5.03098 16.9325 5.05223 16.7475 5.12348C16.6425 5.16473 16.545 5.22098 16.4513 5.28473Z",
    fill: "white"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23_5038_39507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.32 6.37586C15.5775 6.16211 15.8763 5.99961 16.195 5.90086C16.8513 5.69836 17.595 5.77836 18.175 6.14711C18.375 6.27336 18.5538 6.43086 18.74 6.57836C18.925 6.72461 19.1225 6.86211 19.3463 6.94086C19.4675 6.98336 19.5963 7.00836 19.7238 6.99461C19.8388 6.98336 19.95 6.93961 20.045 6.87461C20.14 6.80836 20.22 6.72086 20.28 6.62211C20.4 6.42461 20.4388 6.18461 20.4175 5.95461C20.3763 5.49336 20.1163 5.08711 19.8988 4.67836C19.83 4.55086 19.765 4.42086 19.6825 4.30211C19.4313 3.93586 19.0288 3.69461 18.6075 3.55336C18.1863 3.41211 17.7413 3.36086 17.3 3.30586C17.1025 3.28086 16.9038 3.25461 16.7075 3.27836C16.4813 3.30586 16.2688 3.39711 16.0475 3.45336C15.9425 3.48086 15.8363 3.49961 15.7325 3.52961C15.6288 3.55961 15.5263 3.60086 15.4413 3.66836C15.3188 3.76711 15.2413 3.91586 15.2075 4.06961C15.1738 4.22461 15.1813 4.38461 15.2063 4.54086C15.255 4.85336 15.3725 5.15711 15.3613 5.47336C15.3538 5.68961 15.285 5.90336 15.2938 6.11961C15.2963 6.18336 15.3088 6.31336 15.32 6.37586Z",
    fill: "url(#paint18_linear_5038_39507)"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter23_f_5038_39507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4913 4.39746C17.44 4.46246 17.3938 4.53246 17.3575 4.60996C17.5888 4.65996 17.8088 4.75496 18.0063 4.88621C18.3888 5.13996 18.6788 5.50996 18.8825 5.92246C18.93 5.86996 18.9725 5.81371 19.01 5.75121C18.805 5.32121 18.51 4.93246 18.115 4.66996C17.925 4.54496 17.7138 4.44871 17.4913 4.39746Z",
    fill: "url(#paint19_linear_5038_39507)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask24_5038_39507",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 0,
    width: 18,
    height: 32
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8688 0.5C15.1188 0.5 14.3663 0.6475 13.6863 1.015C12.9638 1.40375 12.3713 2.02625 12.0075 2.76125C11.6425 3.49625 11.5 4.28125 11.4775 5.14625C11.4363 6.78875 11.515 8.51125 11.6388 10.0725C11.6713 10.5475 11.7313 10.825 11.67 11.3138C11.4675 12.3513 10.56 13.0487 10.075 13.96C9.54128 14.965 9.31628 16.1012 8.91378 17.1663C8.54503 18.14 8.02753 19.0537 7.67878 20.035C7.19003 21.4062 7.04378 22.9137 7.36628 24.3337C7.61253 25.4163 8.12628 26.4312 8.81878 27.3C8.71878 27.48 8.62128 27.6638 8.51878 27.8425C8.19753 28.3962 7.80503 28.9225 7.62253 29.5362C7.53128 29.8425 7.49503 30.17 7.55378 30.485C7.61253 30.8 7.77253 31.1012 8.02253 31.3013C8.18628 31.4312 8.38503 31.5162 8.58878 31.5637C8.79253 31.61 9.00378 31.6213 9.21378 31.6175C10.01 31.6 10.7825 31.3587 11.5525 31.1562C12.01 31.0362 12.47 30.93 12.9313 30.8337C14.5738 30.4975 16.4063 30.6325 17.93 30.8525C18.4463 30.9313 18.9588 31.0325 19.4663 31.1562C20.2613 31.3487 21.0525 31.5938 21.87 31.6175C22.085 31.6238 22.3025 31.6137 22.5125 31.5675C22.7225 31.52 22.9263 31.435 23.0938 31.3013C23.345 31.1012 23.505 30.7987 23.5638 30.4837C23.6225 30.1687 23.5863 29.84 23.4938 29.5325C23.3088 28.9175 22.9125 28.3938 22.585 27.8425C22.455 27.6238 22.335 27.4013 22.2063 27.1825C23.1938 26.0738 23.9888 24.7913 24.4488 23.3825C24.95 21.845 25.0425 20.1887 24.8313 18.585C24.62 16.9812 24.1113 15.4262 23.4425 13.9537C22.6025 12.1087 21.8963 11.4412 21.3838 9.82C20.8313 8.0675 21.2875 5.99375 20.8763 4.405C20.73 3.865 20.4963 3.34875 20.195 2.87625C19.8425 2.3225 19.395 1.8275 18.8638 1.4425C18.0163 0.8275 16.9513 0.5 15.8688 0.5Z",
    fill: "white"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask24_5038_39507)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter24_f_5038_39507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.64 11.6663C12.8238 12.1988 13.1925 12.6525 13.63 13.0063C13.775 13.125 13.9288 13.2338 14.1 13.31C14.27 13.3875 14.4588 13.4313 14.645 13.415C14.8275 13.4 15.0013 13.3275 15.1613 13.2375C15.3213 13.1475 15.4688 13.0388 15.6238 12.9413C15.8888 12.7725 16.1725 12.6363 16.4488 12.4863C16.78 12.305 17.1025 12.0988 17.3813 11.8438C17.51 11.7275 17.6288 11.6 17.77 11.5C17.9113 11.3988 18.0813 11.3263 18.2538 11.3388C18.3838 11.3475 18.505 11.4025 18.6325 11.43C18.6963 11.4438 18.7613 11.45 18.8263 11.44C18.89 11.43 18.9525 11.4038 18.9975 11.3563C19.0525 11.2988 19.0775 11.2163 19.0738 11.1363C19.0713 11.0575 19.0438 10.98 19.0063 10.91C18.9325 10.7688 18.82 10.6475 18.77 10.4963C18.725 10.3613 18.7338 10.2163 18.7375 10.075C18.7413 9.9325 18.7388 9.785 18.6738 9.65875C18.6238 9.56375 18.54 9.4875 18.445 9.4375C18.35 9.38625 18.2425 9.36 18.135 9.35C17.92 9.33 17.705 9.3725 17.4888 9.38375C17.2038 9.4 16.9163 9.365 16.63 9.38125C16.2738 9.40375 15.9238 9.50625 15.5663 9.5075C15.1588 9.50875 14.7513 9.375 14.3488 9.43875C14.175 9.46625 14.01 9.52875 13.845 9.58375C13.6788 9.64 13.5075 9.68875 13.3325 9.68625C13.1338 9.6825 12.9413 9.61375 12.7425 9.6C12.6438 9.5925 12.5425 9.6 12.4488 9.635C12.3563 9.67 12.2725 9.73375 12.2263 9.8225C12.2 9.8725 12.1875 9.93 12.185 9.98625C12.1825 10.0438 12.19 10.1 12.2038 10.1563C12.2313 10.2663 12.2825 10.37 12.3238 10.475C12.4738 10.8588 12.5063 11.2775 12.64 11.6663Z",
    fill: "black",
    fillOpacity: 0.258824
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask25_5038_39507",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 0,
    width: 18,
    height: 32
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8688 0.5C15.1188 0.5 14.3663 0.6475 13.6863 1.015C12.9638 1.40375 12.3713 2.02625 12.0075 2.76125C11.6425 3.49625 11.5 4.28125 11.4775 5.14625C11.4363 6.78875 11.515 8.51125 11.6388 10.0725C11.6713 10.5475 11.7313 10.825 11.67 11.3138C11.4675 12.3513 10.56 13.0487 10.075 13.96C9.54128 14.965 9.31628 16.1012 8.91378 17.1663C8.54503 18.14 8.02753 19.0537 7.67878 20.035C7.19003 21.4062 7.04378 22.9137 7.36628 24.3337C7.61253 25.4163 8.12628 26.4312 8.81878 27.3C8.71878 27.48 8.62128 27.6638 8.51878 27.8425C8.19753 28.3962 7.80503 28.9225 7.62253 29.5362C7.53128 29.8425 7.49503 30.17 7.55378 30.485C7.61253 30.8 7.77253 31.1012 8.02253 31.3013C8.18628 31.4312 8.38503 31.5162 8.58878 31.5637C8.79253 31.61 9.00378 31.6213 9.21378 31.6175C10.01 31.6 10.7825 31.3587 11.5525 31.1562C12.01 31.0362 12.47 30.93 12.9313 30.8337C14.5738 30.4975 16.4063 30.6325 17.93 30.8525C18.4463 30.9313 18.9588 31.0325 19.4663 31.1562C20.2613 31.3487 21.0525 31.5938 21.87 31.6175C22.085 31.6238 22.3025 31.6137 22.5125 31.5675C22.7225 31.52 22.9263 31.435 23.0938 31.3013C23.345 31.1012 23.505 30.7987 23.5638 30.4837C23.6225 30.1687 23.5863 29.84 23.4938 29.5325C23.3088 28.9175 22.9125 28.3938 22.585 27.8425C22.455 27.6238 22.335 27.4013 22.2063 27.1825C23.1938 26.0738 23.9888 24.7913 24.4488 23.3825C24.95 21.845 25.0425 20.1887 24.8313 18.585C24.62 16.9812 24.1113 15.4262 23.4425 13.9537C22.6025 12.1087 21.8963 11.4412 21.3838 9.82C20.8313 8.0675 21.2875 5.99375 20.8763 4.405C20.73 3.865 20.4963 3.34875 20.195 2.87625C19.8425 2.3225 19.395 1.8275 18.8638 1.4425C18.0163 0.8275 16.9513 0.5 15.8688 0.5Z",
    fill: "white"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask25_5038_39507)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter25_f_5038_39507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1288 10.1502C12.485 10.3702 12.805 10.6415 13.0738 10.949C13.3225 11.2352 13.5338 11.5602 13.86 11.7715C14.0888 11.9215 14.365 12.0052 14.645 12.0315C14.9738 12.0615 15.3063 12.0127 15.6238 11.9265C15.9175 11.8477 16.2013 11.7352 16.4613 11.5877C16.9575 11.3065 17.3713 10.894 17.9175 10.709C18.0363 10.6677 18.16 10.639 18.275 10.589C18.39 10.5402 18.4988 10.4652 18.5538 10.3602C18.6063 10.2577 18.6038 10.1415 18.6213 10.0302C18.64 9.91023 18.6813 9.79523 18.7038 9.67648C18.7263 9.55773 18.7288 9.43148 18.6738 9.32273C18.6275 9.23273 18.5438 9.16148 18.4475 9.11523C18.3513 9.07023 18.2425 9.05023 18.1338 9.04523C17.9188 9.03523 17.705 9.08648 17.4888 9.10398C17.2038 9.12773 16.9163 9.09398 16.63 9.10273C16.2738 9.11273 15.9225 9.18648 15.5663 9.20273C15.16 9.22023 14.755 9.16023 14.3488 9.14773C14.1725 9.14148 13.995 9.14398 13.8225 9.17273C13.6488 9.20023 13.4788 9.25398 13.3325 9.34398C13.19 9.43023 13.0738 9.54898 12.9438 9.65023C12.8788 9.70148 12.8088 9.74773 12.7338 9.78398C12.6575 9.81898 12.5738 9.84398 12.4888 9.84773C12.445 9.84898 12.4 9.84648 12.3575 9.85273C12.2838 9.86273 12.2163 9.90148 12.1738 9.95648C12.1313 10.0127 12.115 10.084 12.1288 10.1502Z",
    fill: "black"
  })))), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9575 7.81631C14.1488 7.60256 14.2788 7.34131 14.4613 7.12131C14.5525 7.01131 14.6588 6.91006 14.7825 6.83881C14.9063 6.76756 15.0513 6.72756 15.1938 6.74006C15.3525 6.75381 15.5013 6.83256 15.6175 6.94131C15.7338 7.05006 15.82 7.18756 15.8888 7.33131C15.955 7.47006 16.0075 7.61631 16.1025 7.73631C16.2038 7.86381 16.345 7.95006 16.4738 8.05131C16.5375 8.10131 16.6 8.15506 16.65 8.21881C16.7013 8.28256 16.74 8.35631 16.7575 8.43631C16.7738 8.51756 16.765 8.60256 16.7375 8.68006C16.7088 8.75756 16.6613 8.82756 16.6013 8.88506C16.4825 9.00006 16.32 9.06256 16.1563 9.08506C15.8288 9.13131 15.4975 9.03381 15.1663 9.04256C14.8325 9.05256 14.505 9.17006 14.17 9.15881C14.0038 9.15256 13.8338 9.11131 13.6963 9.01631C13.6275 8.96756 13.5675 8.90631 13.5238 8.83506C13.4813 8.76381 13.455 8.68131 13.4513 8.59756C13.4488 8.51756 13.4675 8.43756 13.5 8.36506C13.5313 8.29131 13.5763 8.22506 13.6263 8.16256C13.7275 8.03881 13.8513 7.93631 13.9575 7.81631Z",
    fill: "url(#paint20_radial_5038_39507)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1425 9.88124C12.15 9.91374 12.1613 9.94374 12.1775 9.97249C12.2063 10.02 12.2488 10.0587 12.2938 10.0912C12.3388 10.125 12.3875 10.1525 12.435 10.1812C12.6863 10.34 12.8913 10.5612 13.0738 10.7962C13.3175 11.1112 13.5338 11.46 13.86 11.6887C14.09 11.8512 14.365 11.9425 14.645 11.9712C14.9738 12.0037 15.3063 11.9512 15.6238 11.8575C15.9175 11.7712 16.2013 11.65 16.4613 11.4887C16.9575 11.1837 17.3713 10.7362 17.9175 10.535C18.0363 10.4912 18.16 10.46 18.275 10.4062C18.39 10.3512 18.4988 10.2712 18.5538 10.1562C18.6063 10.0462 18.6038 9.91874 18.6213 9.79749C18.64 9.66874 18.6813 9.54374 18.7038 9.41499C18.7263 9.28624 18.7288 9.14874 18.6738 9.02999C18.6275 8.93249 18.5438 8.85499 18.4475 8.80624C18.3513 8.75624 18.2425 8.73374 18.1338 8.72874C17.9188 8.71874 17.705 8.77374 17.4888 8.79374C17.2038 8.81999 16.9163 8.78249 16.63 8.79124C16.2738 8.80249 15.9225 8.88249 15.5663 8.89999C15.16 8.91874 14.755 8.85624 14.3488 8.83999C14.1725 8.83249 13.995 8.83499 13.8213 8.86499C13.6475 8.89374 13.4775 8.95374 13.3325 9.05374C13.1913 9.15124 13.0788 9.28374 12.9488 9.39624C12.8838 9.45249 12.8138 9.50374 12.7363 9.54124C12.66 9.57874 12.575 9.60249 12.4888 9.59999C12.445 9.59874 12.3988 9.59249 12.3575 9.60499C12.3313 9.61374 12.3075 9.62999 12.2875 9.64874C12.2675 9.66874 12.2513 9.69124 12.2363 9.71374C12.2 9.76624 12.1688 9.82249 12.1425 9.88124Z",
    fill: "url(#paint21_radial_5038_39507)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask26_5038_39507",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 8,
    width: 7,
    height: 4
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1425 9.88124C12.15 9.91374 12.1613 9.94374 12.1775 9.97249C12.2063 10.02 12.2488 10.0587 12.2938 10.0912C12.3388 10.125 12.3875 10.1525 12.435 10.1812C12.6863 10.34 12.8913 10.5612 13.0738 10.7962C13.3175 11.1112 13.5338 11.46 13.86 11.6887C14.09 11.8512 14.365 11.9425 14.645 11.9712C14.9738 12.0037 15.3063 11.9512 15.6238 11.8575C15.9175 11.7712 16.2013 11.65 16.4613 11.4887C16.9575 11.1837 17.3713 10.7362 17.9175 10.535C18.0363 10.4912 18.16 10.46 18.275 10.4062C18.39 10.3512 18.4988 10.2712 18.5538 10.1562C18.6063 10.0462 18.6038 9.91874 18.6213 9.79749C18.64 9.66874 18.6813 9.54374 18.7038 9.41499C18.7263 9.28624 18.7288 9.14874 18.6738 9.02999C18.6275 8.93249 18.5438 8.85499 18.4475 8.80624C18.3513 8.75624 18.2425 8.73374 18.1338 8.72874C17.9188 8.71874 17.705 8.77374 17.4888 8.79374C17.2038 8.81999 16.9163 8.78249 16.63 8.79124C16.2738 8.80249 15.9225 8.88249 15.5663 8.89999C15.16 8.91874 14.755 8.85624 14.3488 8.83999C14.1725 8.83249 13.995 8.83499 13.8213 8.86499C13.6475 8.89374 13.4775 8.95374 13.3325 9.05374C13.1913 9.15124 13.0788 9.28374 12.9488 9.39624C12.8838 9.45249 12.8138 9.50374 12.7363 9.54124C12.66 9.57874 12.575 9.60249 12.4888 9.59999C12.445 9.59874 12.3988 9.59249 12.3575 9.60499C12.3313 9.61374 12.3075 9.62999 12.2875 9.64874C12.2675 9.66874 12.2513 9.69124 12.2363 9.71374C12.2 9.76624 12.1688 9.82249 12.1425 9.88124Z",
    fill: "white"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask26_5038_39507)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter26_f_5038_39507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7376 10.3201C13.6963 10.4913 13.7213 10.6788 13.8076 10.8338C13.8926 10.9888 14.0376 11.1088 14.2063 11.1651C14.4188 11.2363 14.6588 11.2013 14.8576 11.0976C14.9738 11.0376 15.0788 10.9526 15.1451 10.8401C15.1788 10.7851 15.2026 10.7226 15.2113 10.6576C15.2188 10.5938 15.2138 10.5263 15.1913 10.4651C15.1663 10.3988 15.1213 10.3401 15.0676 10.2938C15.0126 10.2476 14.9488 10.2138 14.8801 10.1913C14.7451 10.1463 14.5338 10.1088 14.3913 10.1063C14.1388 10.1013 13.7788 10.1488 13.7376 10.3201Z",
    fill: "#D9B30D"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask27_5038_39507",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 8,
    width: 7,
    height: 4
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1426 9.88124C12.1501 9.91374 12.1613 9.94374 12.1776 9.97249C12.2063 10.02 12.2488 10.0587 12.2938 10.0912C12.3388 10.125 12.3876 10.1525 12.4351 10.1812C12.6863 10.34 12.8913 10.5612 13.0738 10.7962C13.3176 11.1112 13.5338 11.46 13.8601 11.6887C14.0901 11.8512 14.3651 11.9425 14.6451 11.9712C14.9738 12.0037 15.3063 11.9512 15.6238 11.8575C15.9176 11.7712 16.2013 11.65 16.4613 11.4887C16.9576 11.1837 17.3713 10.7362 17.9176 10.535C18.0363 10.4912 18.1601 10.46 18.2751 10.4062C18.3901 10.3512 18.4988 10.2712 18.5538 10.1562C18.6063 10.0462 18.6038 9.91874 18.6213 9.79749C18.6401 9.66874 18.6813 9.54374 18.7038 9.41499C18.7263 9.28624 18.7288 9.14874 18.6738 9.02999C18.6276 8.93249 18.5438 8.85499 18.4476 8.80624C18.3513 8.75624 18.2426 8.73374 18.1338 8.72874C17.9188 8.71874 17.7051 8.77374 17.4888 8.79374C17.2038 8.81999 16.9163 8.78249 16.6301 8.79124C16.2738 8.80249 15.9226 8.88249 15.5663 8.89999C15.1601 8.91874 14.7551 8.85624 14.3488 8.83999C14.1726 8.83249 13.9951 8.83499 13.8213 8.86499C13.6476 8.89374 13.4776 8.95374 13.3326 9.05374C13.1913 9.15124 13.0788 9.28374 12.9488 9.39624C12.8838 9.45249 12.8138 9.50374 12.7363 9.54124C12.6601 9.57874 12.5751 9.60249 12.4888 9.59999C12.4451 9.59874 12.3988 9.59249 12.3576 9.60499C12.3313 9.61374 12.3076 9.62999 12.2876 9.64874C12.2676 9.66874 12.2513 9.69124 12.2363 9.71374C12.2001 9.76624 12.1688 9.82249 12.1426 9.88124Z",
    fill: "white"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask27_5038_39507)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter27_f_5038_39507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0388 8.98264C12.8938 9.06764 12.7551 9.16139 12.6188 9.25764C12.5476 9.30889 12.4751 9.36264 12.4376 9.44139C12.4113 9.49639 12.4051 9.55889 12.4038 9.62014C12.4038 9.68264 12.4076 9.74389 12.3988 9.80514C12.3938 9.84639 12.3826 9.88764 12.3813 9.92889C12.3801 9.95014 12.3813 9.97139 12.3863 9.99139C12.3926 10.0114 12.4026 10.0314 12.4163 10.0464C12.4351 10.0664 12.4601 10.0789 12.4863 10.0864C12.5126 10.0939 12.5388 10.0976 12.5663 10.1039C12.6926 10.1339 12.8026 10.2114 12.8988 10.2989C12.9951 10.3851 13.0826 10.4839 13.1838 10.5651C13.4563 10.7876 13.8176 10.8801 14.1701 10.8851C14.5226 10.8914 14.8713 10.8176 15.2151 10.7401C15.4851 10.6789 15.7551 10.6164 16.0138 10.5201C16.4138 10.3726 16.7838 10.1501 17.1038 9.87139C17.2501 9.74514 17.3863 9.60639 17.5501 9.50389C17.6938 9.41264 17.8551 9.35264 18.0026 9.26639C18.0163 9.25889 18.0288 9.25014 18.0401 9.24139C18.0526 9.23139 18.0626 9.21889 18.0701 9.20639C18.0813 9.18264 18.0813 9.15389 18.0738 9.12889C18.0663 9.10389 18.0513 9.08139 18.0351 9.06014C18.0163 9.03764 17.9963 9.01764 17.9738 8.99764C17.8201 8.86639 17.6126 8.81889 17.4101 8.80264C17.2088 8.78764 17.0051 8.79889 16.8063 8.76514C16.6188 8.73389 16.4413 8.66389 16.2601 8.60639C16.0701 8.54514 15.8763 8.49764 15.6801 8.46514C15.2163 8.38889 14.7401 8.40389 14.2813 8.49889C13.8451 8.59014 13.4226 8.75514 13.0388 8.98264Z",
    fill: "#604405"
  })))), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9926 8.4938C12.7851 8.6338 12.5976 8.80505 12.4388 8.9988C12.3488 9.11005 12.2663 9.2313 12.2213 9.3663C12.1851 9.4738 12.1726 9.5863 12.1501 9.69755C12.1413 9.7388 12.1313 9.78005 12.1326 9.82255C12.1326 9.84255 12.1351 9.8638 12.1413 9.88505C12.1476 9.90505 12.1588 9.9238 12.1726 9.9388C12.1976 9.9638 12.2313 9.97755 12.2651 9.98505C12.3001 9.9913 12.3351 9.99255 12.3701 9.9963C12.5263 10.015 12.6701 10.09 12.8001 10.18C12.9301 10.2688 13.0501 10.3738 13.1838 10.4575C13.4776 10.6438 13.8288 10.7263 14.1776 10.74C14.5251 10.7538 14.8726 10.7013 15.2151 10.6325C15.4863 10.5788 15.7563 10.5138 16.0138 10.4125C16.4088 10.2563 16.7651 10.0175 17.1038 9.7638C17.2588 9.6488 17.4113 9.53005 17.5501 9.3963C17.5963 9.35005 17.6426 9.3038 17.6926 9.2613C17.7426 9.22005 17.7988 9.1838 17.8613 9.1638C17.9563 9.1338 18.0588 9.14255 18.1576 9.1588C18.2313 9.1713 18.3051 9.18755 18.3801 9.18505C18.4176 9.18255 18.4551 9.1763 18.4901 9.16255C18.5251 9.1488 18.5576 9.12755 18.5813 9.09755C18.6126 9.06005 18.6288 9.01005 18.6288 8.9613C18.6288 8.9113 18.6138 8.86255 18.5888 8.82005C18.5388 8.73505 18.4526 8.67755 18.3626 8.63755C18.2388 8.58255 18.1051 8.5563 17.9738 8.5238C17.5701 8.4263 17.1776 8.28255 16.8063 8.09755C16.6213 8.0063 16.4413 7.90505 16.2601 7.80755C16.0726 7.70755 15.8826 7.6113 15.6801 7.5488C15.2251 7.4113 14.7301 7.4563 14.2813 7.61255C13.7838 7.78505 13.3338 8.09255 12.9926 8.4938Z",
    fill: "url(#paint22_linear_5038_39507)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask28_5038_39507",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 7,
    width: 7,
    height: 4
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9926 8.4938C12.7851 8.6338 12.5976 8.80505 12.4388 8.9988C12.3488 9.11005 12.2663 9.2313 12.2213 9.3663C12.1851 9.4738 12.1726 9.5863 12.1501 9.69755C12.1413 9.7388 12.1313 9.78005 12.1326 9.82255C12.1326 9.84255 12.1351 9.8638 12.1413 9.88505C12.1476 9.90505 12.1588 9.9238 12.1726 9.9388C12.1976 9.9638 12.2313 9.97755 12.2651 9.98505C12.3001 9.9913 12.3351 9.99255 12.3701 9.9963C12.5263 10.015 12.6701 10.09 12.8001 10.18C12.9301 10.2688 13.0501 10.3738 13.1838 10.4575C13.4776 10.6438 13.8288 10.7263 14.1776 10.74C14.5251 10.7538 14.8726 10.7013 15.2151 10.6325C15.4863 10.5788 15.7563 10.5138 16.0138 10.4125C16.4088 10.2563 16.7651 10.0175 17.1038 9.7638C17.2588 9.6488 17.4113 9.53005 17.5501 9.3963C17.5963 9.35005 17.6426 9.3038 17.6926 9.2613C17.7426 9.22005 17.7988 9.1838 17.8613 9.1638C17.9563 9.1338 18.0588 9.14255 18.1576 9.1588C18.2313 9.1713 18.3051 9.18755 18.3801 9.18505C18.4176 9.18255 18.4551 9.1763 18.4901 9.16255C18.5251 9.1488 18.5576 9.12755 18.5813 9.09755C18.6126 9.06005 18.6288 9.01005 18.6288 8.9613C18.6288 8.9113 18.6138 8.86255 18.5888 8.82005C18.5388 8.73505 18.4526 8.67755 18.3626 8.63755C18.2388 8.58255 18.1051 8.5563 17.9738 8.5238C17.5701 8.4263 17.1776 8.28255 16.8063 8.09755C16.6213 8.0063 16.4413 7.90505 16.2601 7.80755C16.0726 7.70755 15.8826 7.6113 15.6801 7.5488C15.2251 7.4113 14.7301 7.4563 14.2813 7.61255C13.7838 7.78505 13.3338 8.09255 12.9926 8.4938Z",
    fill: "white"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask28_5038_39507)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter28_f_5038_39507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.1813 8.59394C16.1563 8.56394 16.1213 8.54144 16.0838 8.53019C16.0463 8.51894 16.0063 8.51894 15.9676 8.52519C15.8901 8.53894 15.8201 8.58019 15.7551 8.62519C15.5713 8.75144 15.4088 8.90769 15.2663 9.08019C15.0788 9.30894 14.9238 9.5727 14.8713 9.86395C14.8626 9.9127 14.8576 9.96394 14.8626 10.0127C14.8688 10.0627 14.8876 10.1114 14.9238 10.1464C14.9538 10.1777 14.9963 10.1964 15.0388 10.2027C15.0826 10.2089 15.1276 10.2027 15.1688 10.1889C15.2513 10.1614 15.3201 10.1027 15.3863 10.0452C15.7451 9.72269 16.0701 9.3377 16.2001 8.8727C16.2126 8.82645 16.2238 8.77894 16.2238 8.73019C16.2238 8.68144 16.2113 8.63269 16.1813 8.59394Z",
    fill: "#F6DA4A"
  })))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    filter: "url(#filter29_f_5038_39507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0901 7.88272C13.9938 7.85147 13.8363 8.02022 13.8876 8.10647C13.9013 8.13022 13.9451 8.16022 13.9751 8.14397C14.0188 8.12022 14.0551 8.03272 14.1026 7.99897C14.1338 7.97647 14.1276 7.89397 14.0901 7.88272Z",
    fill: "url(#paint23_radial_5038_39507)"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    filter: "url(#filter30_f_5038_39507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.32 7.9276C15.345 8.0076 15.4738 7.99385 15.5488 8.0326C15.6138 8.06635 15.6663 8.1401 15.74 8.1426C15.81 8.14385 15.92 8.1176 15.9288 8.0476C15.94 7.95635 15.8063 7.8976 15.72 7.86385C15.6088 7.82135 15.4663 7.79885 15.3625 7.85635C15.3388 7.8701 15.3125 7.90135 15.32 7.9276Z",
    fill: "url(#paint24_radial_5038_39507)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask29_5038_39507",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 7,
    width: 7,
    height: 5
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1426 9.88124C12.1501 9.91374 12.1613 9.94374 12.1776 9.97249C12.2063 10.02 12.2488 10.0587 12.2938 10.0912C12.3388 10.125 12.3876 10.1525 12.4351 10.1812C12.6863 10.34 12.8913 10.5612 13.0738 10.7962C13.3176 11.1112 13.5338 11.46 13.8601 11.6887C14.0901 11.8512 14.3651 11.9425 14.6451 11.9712C14.9738 12.0037 15.3063 11.9512 15.6238 11.8575C15.9176 11.7712 16.2013 11.65 16.4613 11.4887C16.9576 11.1837 17.3713 10.7362 17.9176 10.535C18.0363 10.4912 18.1601 10.46 18.2751 10.4062C18.3901 10.3512 18.4988 10.2712 18.5538 10.1562C18.6063 10.0462 18.6038 9.91874 18.6213 9.79749C18.6401 9.66874 18.6813 9.54374 18.7038 9.41499C18.7263 9.28624 18.7288 9.14874 18.6738 9.02999C18.6276 8.93249 18.5438 8.85499 18.4476 8.80624C18.3513 8.75624 18.2426 8.73374 18.1338 8.72874C17.9188 8.71874 17.7051 8.77374 17.4888 8.79374C17.2038 8.81999 16.9163 8.78249 16.6301 8.79124C16.2738 8.80249 15.9226 8.88249 15.5663 8.89999C15.1601 8.91874 14.7551 8.85624 14.3488 8.83999C14.1726 8.83249 13.9951 8.83499 13.8213 8.86499C13.6476 8.89374 13.4776 8.95374 13.3326 9.05374C13.1913 9.15124 13.0788 9.28374 12.9488 9.39624C12.8838 9.45249 12.8138 9.50374 12.7363 9.54124C12.6601 9.57874 12.5751 9.60249 12.4888 9.59999C12.4451 9.59874 12.3988 9.59249 12.3576 9.60499C12.3313 9.61374 12.3076 9.62999 12.2876 9.64874C12.2676 9.66874 12.2513 9.69124 12.2363 9.71374C12.2001 9.76624 12.1688 9.82249 12.1426 9.88124Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9926 8.4938C12.7851 8.6338 12.5976 8.80505 12.4388 8.9988C12.3488 9.11005 12.2663 9.2313 12.2213 9.3663C12.1851 9.4738 12.1726 9.5863 12.1501 9.69755C12.1413 9.7388 12.1313 9.78005 12.1326 9.82255C12.1326 9.84255 12.1351 9.8638 12.1413 9.88505C12.1476 9.90505 12.1588 9.9238 12.1726 9.9388C12.1976 9.9638 12.2313 9.97755 12.2651 9.98505C12.3001 9.9913 12.3351 9.99255 12.3701 9.9963C12.5263 10.015 12.6701 10.09 12.8001 10.18C12.9301 10.2688 13.0501 10.3738 13.1838 10.4575C13.4776 10.6438 13.8288 10.7263 14.1776 10.74C14.5251 10.7538 14.8726 10.7013 15.2151 10.6325C15.4863 10.5788 15.7563 10.5138 16.0138 10.4125C16.4088 10.2563 16.7651 10.0175 17.1038 9.7638C17.2588 9.6488 17.4113 9.53005 17.5501 9.3963C17.5963 9.35005 17.6426 9.3038 17.6926 9.2613C17.7426 9.22005 17.7988 9.1838 17.8613 9.1638C17.9563 9.1338 18.0588 9.14255 18.1576 9.1588C18.2313 9.1713 18.3051 9.18755 18.3801 9.18505C18.4176 9.18255 18.4551 9.1763 18.4901 9.16255C18.5251 9.1488 18.5576 9.12755 18.5813 9.09755C18.6126 9.06005 18.6288 9.01005 18.6288 8.9613C18.6288 8.9113 18.6138 8.86255 18.5888 8.82005C18.5388 8.73505 18.4526 8.67755 18.3626 8.63755C18.2388 8.58255 18.1051 8.5563 17.9738 8.5238C17.5701 8.4263 17.1776 8.28255 16.8063 8.09755C16.6213 8.0063 16.4413 7.90505 16.2601 7.80755C16.0726 7.70755 15.8826 7.6113 15.6801 7.5488C15.2251 7.4113 14.7301 7.4563 14.2813 7.61255C13.7838 7.78505 13.3338 8.09255 12.9926 8.4938Z",
    fill: "white"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask29_5038_39507)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter31_f_5038_39507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.6588 9.14395C18.6472 9.245 18.6037 9.3418 18.5378 9.41307C18.4719 9.48433 18.3891 9.52422 18.3075 9.52395C18.2261 9.52399 18.1524 9.48401 18.1027 9.41277C18.053 9.34153 18.0314 9.24485 18.0425 9.14395C18.0482 9.09382 18.0617 9.04418 18.0824 8.99787C18.1031 8.95156 18.1306 8.9095 18.1632 8.87408C18.1958 8.83866 18.233 8.81059 18.2726 8.79148C18.3121 8.77237 18.3533 8.76259 18.3938 8.7627C18.4342 8.76265 18.4732 8.77248 18.5084 8.79162C18.5436 8.81076 18.5744 8.83884 18.599 8.87425C18.6236 8.90966 18.6416 8.95171 18.6518 8.99798C18.6621 9.04426 18.6645 9.09386 18.6588 9.14395Z",
    fill: "url(#paint25_linear_5038_39507)"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_5038_39507",
    x: 9.56003,
    y: 13.6364,
    width: 4.16625,
    height: 3.91863,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.08,
    result: "effect1_foregroundBlur_5038_39507"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_5038_39507",
    x: 15.2476,
    y: 13.2687,
    width: 6.2834,
    height: 4.50611,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1225,
    result: "effect1_foregroundBlur_5038_39507"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_5038_39507",
    x: 13.0238,
    y: 13.8061,
    width: 2.67624,
    height: 2.83756,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.085,
    result: "effect1_foregroundBlur_5038_39507"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_5038_39507",
    x: 13.0003,
    y: 17.3301,
    width: 1.08258,
    height: 7.09131,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.15625,
    result: "effect1_foregroundBlur_5038_39507"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_5038_39507",
    x: 21.7996,
    y: 16.4583,
    width: 1.97545,
    height: 1.99791,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.2225,
    result: "effect1_foregroundBlur_5038_39507"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_5038_39507",
    x: 16.955,
    y: 1.43859,
    width: 2.63886,
    height: 2.54664,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.21625,
    result: "effect1_foregroundBlur_5038_39507"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_5038_39507",
    x: 19.5103,
    y: 9.84211,
    width: 1.70158,
    height: 1.85094,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0975,
    result: "effect1_foregroundBlur_5038_39507"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_5038_39507",
    x: 7.21752,
    y: 15.7906,
    width: 3.38795,
    height: 7.34938,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1225,
    result: "effect1_foregroundBlur_5038_39507"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_5038_39507",
    x: 21.005,
    y: 15.076,
    width: 3.62308,
    height: 9.32352,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.14875,
    result: "effect1_foregroundBlur_5038_39507"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_f_5038_39507",
    x: 2.06473,
    y: 21.8122,
    width: 11.1258,
    height: 11.0396,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.4225,
    result: "effect1_foregroundBlur_5038_39507"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_f_5038_39507",
    x: 2.7106,
    y: 21.723,
    width: 9.40785,
    height: 9.92207,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.2625,
    result: "effect1_foregroundBlur_5038_39507"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_f_5038_39507",
    x: 8.82002,
    y: 23.9464,
    width: 2.99502,
    height: 5.30258,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.04,
    result: "effect1_foregroundBlur_5038_39507"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_f_5038_39507",
    x: 19.1653,
    y: 23.5687,
    width: 8.66793,
    height: 9.34854,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.24375,
    result: "effect1_foregroundBlur_5038_39507"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_f_5038_39507",
    x: 19.6313,
    y: 22.0222,
    width: 10.5787,
    height: 10.6987,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.515,
    result: "effect1_foregroundBlur_5038_39507"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_f_5038_39507",
    x: 20.2288,
    y: 21.6223,
    width: 9.69135,
    height: 9.64936,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.39,
    result: "effect1_foregroundBlur_5038_39507"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_f_5038_39507",
    x: 20.8113,
    y: 22.8462,
    width: 6.13249,
    height: 1.16398,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.05125,
    result: "effect1_foregroundBlur_5038_39507"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_f_5038_39507",
    x: 21.4657,
    y: 22.8519,
    width: 4.89193,
    height: 4.3666,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.30625,
    result: "effect1_foregroundBlur_5038_39507"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter17_f_5038_39507",
    x: 21.7982,
    y: 22.9793,
    width: 4.22693,
    height: 2.83148,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.14,
    result: "effect1_foregroundBlur_5038_39507"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter18_f_5038_39507",
    x: 22.1255,
    y: 21.6609,
    width: 4.20221,
    height: 2.20025,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.11,
    result: "effect1_foregroundBlur_5038_39507"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter19_f_5038_39507",
    x: 22.1255,
    y: 21.6609,
    width: 4.20221,
    height: 2.20025,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.11,
    result: "effect1_foregroundBlur_5038_39507"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter20_f_5038_39507",
    x: 12.983,
    y: 6.42955,
    width: 0.785735,
    height: 1.12771,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.055,
    result: "effect1_foregroundBlur_5038_39507"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter21_f_5038_39507",
    x: 12.913,
    y: 4.57889,
    width: 1.56952,
    height: 1.41742,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.015,
    result: "effect1_foregroundBlur_5038_39507"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter22_f_5038_39507",
    x: 17.0121,
    y: 6.32598,
    width: 0.976709,
    height: 0.965234,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.05625,
    result: "effect1_foregroundBlur_5038_39507"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter23_f_5038_39507",
    x: 17.325,
    y: 4.36496,
    width: 1.71753,
    height: 1.5899,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.01625,
    result: "effect1_foregroundBlur_5038_39507"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter24_f_5038_39507",
    x: 11.7471,
    y: 8.90723,
    width: 7.76459,
    height: 4.94873,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.21875,
    result: "effect1_foregroundBlur_5038_39507"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter25_f_5038_39507",
    x: 11.924,
    y: 8.84395,
    width: 6.99479,
    height: 3.39658,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1,
    result: "effect1_foregroundBlur_5038_39507"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter26_f_5038_39507",
    x: 13.5256,
    y: 9.91346,
    width: 1.8814,
    height: 1.48168,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.09625,
    result: "effect1_foregroundBlur_5038_39507"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter27_f_5038_39507",
    x: 12.2184,
    y: 8.254,
    width: 6.02318,
    height: 2.79424,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.08125,
    result: "effect1_foregroundBlur_5038_39507"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter28_f_5038_39507",
    x: 14.6781,
    y: 8.3385,
    width: 1.72822,
    height: 2.04908,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.09125,
    result: "effect1_foregroundBlur_5038_39507"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter29_f_5038_39507",
    x: 13.8526,
    y: 7.85391,
    width: 0.294995,
    height: 0.319531,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0125,
    result: "effect1_foregroundBlur_5038_39507"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter30_f_5038_39507",
    x: 15.2937,
    y: 7.79678,
    width: 0.660718,
    height: 0.370801,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0125,
    result: "effect1_foregroundBlur_5038_39507"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter31_f_5038_39507",
    x: 17.9822,
    y: 8.7052,
    width: 0.737131,
    height: 0.87623,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.02875,
    result: "effect1_foregroundBlur_5038_39507"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_5038_39507",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.1475 15.6489) scale(2.375 2.25)"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.25
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_5038_39507",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.2176 16.9499) scale(2.95 2.25)"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.25
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_5038_39507",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.2763 16.4336) scale(1.16875 1.25)"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.25
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5038_39507",
    x1: 5.39756,
    y1: 24.6265,
    x2: 10.5388,
    y2: 33.2527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B98309"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#382605"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5038_39507",
    x1: 10.5588,
    y1: 26.8539,
    x2: 12.1763,
    y2: 29.9014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBC40C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBC40C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5038_39507",
    x1: 20.8663,
    y1: 26.9948,
    x2: 21.275,
    y2: 29.966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_5038_39507",
    x1: 21.4376,
    y1: 32.1277,
    x2: 26.6176,
    y2: 23.7302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E2A06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD780A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_5038_39507",
    x1: 22.8513,
    y1: 23.0842,
    x2: 22.6988,
    y2: 24.4554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3CD0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3CD0C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_5038_39507",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.7138 24.8165) rotate(15) scale(2.4575 2.58)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#110800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A65A00",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF921E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_5038_39507",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.7138 24.2363) rotate(-2.42) scale(2.4675 1.8575)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#110800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A65A00",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF921E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_5038_39507",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.5813 22.5774) rotate(23.5) scale(0.86875 0.40125)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C7C7C",
    stopOpacity: 0.33
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_5038_39507",
    x1: 23.2113,
    y1: 22.1974,
    x2: 23.5338,
    y2: 22.1836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C7C7C",
    stopOpacity: 0.33
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_5038_39507",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.3113 6.9264) rotate(-0.6) scale(1.28 1.96)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFEFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FEFEFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4D4D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_5038_39507",
    x1: 13.0363,
    y1: 6.3298,
    x2: 13.6651,
    y2: 7.45355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757574",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#757574"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#757574"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#757574",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_5038_39507",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.1113 5.96744) rotate(-9.35) scale(0.78125 0.72125)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#797978"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_5038_39507",
    x1: 12.9488,
    y1: 4.56371,
    x2: 14.31,
    y2: 5.95371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#646464",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#646464",
    stopOpacity: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#646464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#646464",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#646464",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_5038_39507",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.2575 6.92598) rotate(-1.8) scale(1.705 1.96)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFEFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FEFEFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4D4D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_5038_39507",
    x1: 17.2338,
    y1: 6.40656,
    x2: 17.9576,
    y2: 7.26406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#949494",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#949494",
    stopOpacity: 0.39
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_5038_39507",
    x1: 16.6125,
    y1: 5.02836,
    x2: 18.915,
    y2: 6.37586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#747474"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C7C7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_5038_39507",
    x1: 17.395,
    y1: 4.44496,
    x2: 18.9275,
    y2: 5.89246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#646464",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#646464",
    stopOpacity: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#646464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#646464",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#646464",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_5038_39507",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.705 8.01506) rotate(-36) scale(1.43 1.2975)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#020204"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#020204"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C5C5C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_5038_39507",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.2213 9.32624) rotate(-22.4) scale(3.39375 2.38375)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2940A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#D89C08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#B67E07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#946106"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_5038_39507",
    x1: 12.2613,
    y1: 9.15755,
    x2: 18.3463,
    y2: 9.11005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD780A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D89E08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#EDB80B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#EBC80D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#F5D838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#F6D811"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5CD31"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_5038_39507",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.0138 7.98522) scale(0.165 0.1775)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A2903"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#735208"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC8C04"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_5038_39507",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.5813 7.9626) scale(0.3475 0.2025)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A2903"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#735208"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC8C04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_5038_39507",
    x1: 18.3425,
    y1: 8.93645,
    x2: 18.3425,
    y2: 9.38645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5CE2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D79B08"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5038_39507"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_5038_39507"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 32,
    fill: "white",
    transform: "translate(2.5 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinuxLogo);
export default __webpack_public_path__ + "static/media/linux_logo.5d496f6be8455fb9ce72f7d7fadf740b.svg";
export { ForwardRef as ReactComponent };